import  { useState, useRef, useEffect, useContext } from "react";
import headeLogo from "../../../assets/images/SS.webp";
import binImg from "../../../assets/images/Bin.png";
import { Radio } from "antd";
import close from "../../../assets/images/close.png";
// import ComboBox from 'shersoft-combov1';
import ComboBox1 from "../../../../src/components/ComboBoxes/ComboBox1";
import ComboBox from "../../../../src/components/ComboBoxes/ComboBox";
import SherComboBox from "../../../../src/components/ComboBoxes/SherComboBox";
import ActionToolbar from "../../../components/NavBars/ActionToolbar";
import WindowHeader from "../../Layout/WindowHeader/WindowHeader";
import axios from "axios";
import { AuthContext } from "../../../context/AuthContext";
import { useDbContext } from "../../../context/DbContext";
// import ComboBox2 from "../../../../src/components/ComboBoxes/ComboBox2";
import io from "socket.io-client";
import { useSelector } from "react-redux";
import { selectMenuPermissions } from "../../../app/permissionsSlice";
import { selectGeneralSettings } from "../../../app/settingsSlice";
import { selectActiveFyid } from "../../../app/financialYearSlice";
import { useActiveFyLimits } from "../../../utils/fyDateValidation";
import { selectActiveLocation } from "../../../app/locationSlice";
import GridDesign from "../../GridDesign/GridDesign";
import FormDesign, { FormDesignProvider, useFormDesign } from "../../FormDesign/FormDesign";


const defaultPurchaseGridColumns = [
  {
    sNo: 1,
    columnName: "Slno",
    width: 40,
    orderNo: 0,
    header: "SINo",
    show: true,
    textBox: "txt_slno",
    label: "lbl",
  },
  {
    sNo: 2,
    columnName: "ItemCode",
    width: 65,
    orderNo: 1,
    header: "ItemCode",
    show: true,
    textBox: "cmb_ItemCode",
    label: "lbl",
  },
  {
    sNo: 3,
    columnName: "ItemName",
    width: 80,
    orderNo: 2,
    header: "ProductName",
    show: true,
    textBox: "Cmb_ItemName",
    label: "lbl",
  },
  {
    sNo: 4,
    columnName: "ModelName",
    width: 80,
    orderNo: 3,
    header: "ModelName",
    show: true,
    textBox: "cmb_model",
    label: "lbl",
  },
  {
    sNo: 5,
    columnName: "PRate",
    width: 60,
    orderNo: 4,
    header: "Rate/Gm",
    show: true,
    textBox: "Txt_Prate",
    label: "lbl",
  },
  {
    sNo: 6,
    columnName: "Qty",
    width: 35,
    orderNo: 5,
    header: "Qty",
    show: true,
    textBox: "Txt_Qty",
    label: "lbl",
  },
  {
    sNo: 7,
    columnName: "GrWt",
    width: 60,
    orderNo: 6,
    header: "GrWt",
    show: true,
    textBox: "txt_grwt",
    label: "lbl",
  },
  {
    sNo: 8,
    columnName: "StoneWt",
    width: 50,
    orderNo: 7,
    header: "StoneWt",
    show: true,
    textBox: "txt_stonewt",
    label: "lbl",
  },
  {
    sNo: 9,
    columnName: "MudLess",
    width: 52,
    orderNo: 8,
    header: "MudLess",
    show: true,
    textBox: "txt_mudless",
    label: "lbl",
  },
  {
    sNo: 10,
    columnName: "Wstg",
    width: 70,
    orderNo: 9,
    header: "Wstg(Gm)+",
    show: true,
    textBox: "txt_wstg",
    label: "lbl",
  },
  {
    sNo: 11,
    columnName: "NetWt",
    width: 65,
    orderNo: 10,
    header: "NetWt",
    show: true,
    textBox: "txt_netwt",
    label: "lbl",
  },
  {
    sNo: 12,
    columnName: "Touch",
    width: 55,
    orderNo: 11,
    header: "Touch%",
    show: true,
    textBox: "txt_touch",
    label: "lbl",
  },
  {
    sNo: 13,
    columnName: "Div",
    width: 55,
    orderNo: 12,
    header: "Div%",
    show: true,
    textBox: "txt_div",
    label: "lbl",
  },
  {
    sNo: 14,
    columnName: "StoneAmt",
    width: 70,
    orderNo: 13,
    header: "StoneAmt",
    show: true,
    textBox: "txt_stoneamt",
    label: "lbl",
  },
  {
    sNo: 15,
    columnName: "Mc",
    width: 50,
    orderNo: 14,
    header: "Mc",
    show: true,
    textBox: "txt_mc",
    label: "lbl",
  },
  {
    sNo: 16,
    columnName: "Gross",
    width: 80,
    orderNo: 15,
    header: "GrossValue",
    show: true,
    textBox: "txt_GrossValue",
    label: "lbl",
  },
  {
    sNo: 17,
    columnName: "CGST",
    width: 50,
    orderNo: 16,
    header: "CGST",
    show: true,
    textBox: "txt_CGST",
    label: "lbl",
  },
  {
    sNo: 18,
    columnName: "SGST",
    width: 50,
    orderNo: 17,
    header: "SGST",
    show: true,
    textBox: "txt_SGST",
    label: "lbl",
  },
  {
    sNo: 19,
    columnName: "IGST",
    width: 50,
    orderNo: 18,
    header: "IGST",
    show: true,
    textBox: "txt_IGST",
    label: "lbl",
  },
  {
    sNo: 20,
    columnName: "Net",
    width: 70,
    orderNo: 19,
    header: "Amount",
    show: true,
    textBox: "txt_netvalue",
    label: "lbl",
  },
];

const defaultPurchaseFormFields = [
  // ── Top Header Fields ──
  {
    fieldId: "EntryNo",
    fieldName: "Entry No",
    tabIndex: 26,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "PoNo",
    fieldName: "Po No",
    tabIndex: 27,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Text",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "Tax",
    fieldName: "Tax / NonTax",
    tabIndex: 2,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: true,
    type: "Checkbox",
    fontSize: 10,
    fontStyle: "Normal",
  },
  {
    fieldId: "CashorSupplier",
    fieldName: "Cash / Supplier",
    tabIndex: 0,
    defaultValue: "CASH",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "SupplierName",
    fieldName: "Supplier Name",
    tabIndex: 1,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "SupplierInvNo",
    fieldName: "Supplier InvNo",
    tabIndex: 5,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Text",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "Amount",
    fieldName: "Amount",
    tabIndex: 6,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "Date",
    fieldName: "Date",
    tabIndex: 3,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Date",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "InvoiceDate",
    fieldName: "Invoice Date",
    tabIndex: 4,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Date",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "DetailsBtn",
    fieldName: "Details",
    tabIndex: 28,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "PurchaseAC",
    fieldName: "Purchase A/C",
    tabIndex: 29,
    defaultValue: "GENERAL PURCHASE A/C",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "Type",
    fieldName: "Type",
    tabIndex: 30,
    defaultValue: "PURCHASE",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "OB",
    fieldName: "OB",
    tabIndex: 31,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "Salesman",
    fieldName: "Salesman",
    tabIndex: 32,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "Location",
    fieldName: "Location",
    tabIndex: 33,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "OW",
    fieldName: "OW",
    tabIndex: 34,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Text",
    fontSize: 11,
    fontStyle: "Normal",
  },
  // ── Grid ──
  {
    fieldId: "Grid",
    fieldName: "Purchase Grid",
    tabIndex: 7,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Grid",
  },
  // ── Action Toolbar Buttons ──
  {
    fieldId: "SaveBtn",
    fieldName: "Save",
    tabIndex: 25,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "PrintBtn",
    fieldName: "Print",
    tabIndex: 35,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "ClearBtn",
    fieldName: "Clear",
    tabIndex: 36,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "FindBtn",
    fieldName: "Find",
    tabIndex: 37,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "EditBtn",
    fieldName: "Edit",
    tabIndex: 38,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "DeleteBtn",
    fieldName: "Delete",
    tabIndex: 39,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "ExitBtn",
    fieldName: "Exit",
    tabIndex: 40,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  // ── Bottom Section Fields ──
  {
    fieldId: "EditItemBtn",
    fieldName: "Edit Item",
    tabIndex: 41,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "RemoveItemBtn",
    fieldName: "Remove Item",
    tabIndex: 42,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "PrintOB",
    fieldName: "Print OB",
    tabIndex: 45,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Checkbox",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "CashAC",
    fieldName: "Cash Acc",
    tabIndex: 43,
    defaultValue: "CASH",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "TotalPureWt",
    fieldName: "Total Pure Wt",
    tabIndex: 44,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "CashPaid",
    fieldName: "Cash Paid",
    tabIndex: 24,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "TotalLess",
    fieldName: "Total Less",
    tabIndex: 45,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "ExchangeNo",
    fieldName: "Exchange No",
    tabIndex: 46,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "ExchangeAmt",
    fieldName: "Exchange Amount",
    tabIndex: 47,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "ExchangeBtn",
    fieldName: "Exchange", 
    tabIndex: 48,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "ReturnNo",
    fieldName: "Return No",
    tabIndex: 49,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "ReturnAmt",
    fieldName: "Return Amount",
    tabIndex: 50,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "ReturnBtn",
    fieldName: "Return",
    tabIndex: 51,
    defaultValue: "",
    visible: true,  
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "TdsPerc",
    fieldName: "TDS %",
    tabIndex: 52,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "TdsAmt",
    fieldName: "TDS Amount",
    tabIndex: 53,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false, 
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "Cess",
    fieldName: "Cess",
    tabIndex: 54,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "OtherCharges",
    fieldName: "Other Charges",
    tabIndex: 21,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "Discount",
    fieldName: "Discount",
    tabIndex: 22,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "RoundOff",
    fieldName: "Round Off",
    tabIndex: 23,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "RoundOffAmt",
    fieldName: "Round Off Amount",
    tabIndex: 55,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "CurrentWeight",
    fieldName: "Current Weight",
    tabIndex: 56,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "CurrentBalance",
    fieldName: "Current Balance",
    tabIndex: 57,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "GrandTotal",
    fieldName: "Grand Total",
    tabIndex: 58,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 20,
    fontStyle: "Bold",
  },
  // ── Grid Inputs ──
  {
    fieldId: "grid_ItemCode",
    fieldName: "Grid - Item Code",
    tabIndex: 8,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
  },
  {
    fieldId: "grid_ItemName",
    fieldName: "Grid - Item Name",
    tabIndex: 9,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
  },
  {
    fieldId: "grid_ModelName",
    fieldName: "Grid - Model Name",
    tabIndex: 10,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
  },
  {
    fieldId: "grid_PRate",
    fieldName: "Grid - Purchase Rate",
    tabIndex: 11,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_Qty",
    fieldName: "Grid - Qty",
    tabIndex: 12,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_GrWt",
    fieldName: "Grid - Gross Wt",
    tabIndex: 13,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_StoneWt",
    fieldName: "Grid - Stone Wt",
    tabIndex: 14,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_MudLess",
    fieldName: "Grid - Mud Less",
    tabIndex: 15,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_Wstg",
    fieldName: "Grid - Waste",
    tabIndex: 16,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_NetWt",
    fieldName: "Grid - Net Wt",
    tabIndex: 64,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_Touch",
    fieldName: "Grid - Touch",
    tabIndex: 17,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_Div",
    fieldName: "Grid - Div",
    tabIndex: 18,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_StoneAmt",
    fieldName: "Grid - Stone Amt",
    tabIndex: 19,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_Mc",
    fieldName: "Grid - Mc",
    tabIndex: 20,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_Gross",
    fieldName: "Grid - Gross Value",
    tabIndex: 59,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_CGST",
    fieldName: "Grid - CGST",
    tabIndex: 60,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_SGST",
    fieldName: "Grid - SGST",
    tabIndex: 61,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_IGST",
    fieldName: "Grid - IGST",
    tabIndex: 62,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_Net",
    fieldName: "Grid - Net Amount",
    tabIndex: 63,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  // ── Breakout / Row-Break Config Pseudo-Fields ──
  {
    fieldId: "__GridBreakoutColumn",
    fieldName: "Grid Breakout Column",
    tabIndex: 9999,
    defaultValue: "ItemName",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
  {
    fieldId: "__GridBreakoutTarget",
    fieldName: "Grid Breakout Target",
    tabIndex: 9999,
    defaultValue: "OtherCharges",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
  {
    fieldId: "__GridRowBreakColumn",
    fieldName: "Grid Row-Break Column",
    tabIndex: 9999,
    defaultValue: "Mc",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
  {
    fieldId: "__GridRowBreakTarget",
    fieldName: "Grid Row-Break Target",
    tabIndex: 9999,
    defaultValue: "ItemCode",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
];

// Main export wrapper
function PurchaseEntry(props) {
  const { dbCode } = useDbContext();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const vType = props.voucherType || "Purchase Entry";

  return (
    <FormDesignProvider
      formName={vType}
      defaultFields={defaultPurchaseFormFields}
      dbCode={dbCode}
      apiBaseUrl={apiBaseUrl}
    >
      <PurchaseEntryInner {...props} />
    </FormDesignProvider>
  );
}

function PurchaseEntryInner({
  onClose,
  Open,
  OpenPReg,
  formId,
  formName,
  voucherType,
  zIndex,
}) {
  const [value, setValue] = useState(1);
  const [loading, setLoading] = useState(false);
  // const [tableData, setTableData] = useState([...Array(15).fill({})]); // Initial 15 rows
  const tableContainerRef = useRef(null);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const { dbCode } = useDbContext();
  const activeFyid = useSelector(selectActiveFyid);
  const activeLocation = useSelector(selectActiveLocation);
  const { minDate, maxDate, validateAndAlert, isDateInFy } = useActiveFyLimits();
  const [frmId, setfrmid] = useState(() => parseInt(formId) || 0);
  const fyid = activeFyid || Number(sessionStorage.getItem("selectedFyId")) || Number(localStorage.getItem("selectedFyId")) || 0;

  const [fname, setfname] = useState("");
  const [vType, setVType] = useState("");
  const permissions = useSelector(selectMenuPermissions);
  const GeneralSettings = useSelector(selectGeneralSettings);

  const [decimal, setDecimal] = useState(3);

  // Navigation states
  const [firstEntryNo, setFirstEntryNo] = useState(null);
  const [lastEntryNo, setLastEntryNo] = useState(null);
  const [currentEntryNo, setCurrentEntryNo] = useState(null);
  const [isNavigating, setIsNavigating] = useState(false);

  // Settings and Grid Design modal states
  const [showGridDesignModal, setShowGridDesignModal] = useState(false);
  const [showFormDesignModal, setShowFormDesignModal] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const dropdownRef = useRef(null);

  const [gridColumns, setGridColumns] = useState(defaultPurchaseGridColumns);

  const {
    fields: formFields,
    loading: formDesignerLoading,
    registerRef,
    handleKeyDown: handleDynamicKeyDown,
    focusField,
    getLabelStyle: getLabelStyleRaw,
    getInputStyle: getInputStyleRaw,
    getContainerStyle,
    isFieldVisible,
    isFieldDisabled,
    isFieldReadOnly,
    getFieldConfig,
    triggerInitialFocus,
    setFields: setFormFields,
    activeFieldId,
    rowBreakColumn,
    rowBreakTarget,
    breakoutColumn,
    setRowBreakColumn,
    setRowBreakTarget,
    setBreakoutColumn,
    setBreakoutTarget,
  } = useFormDesign();

  const getLabelStyle = (fieldId, defaultStyles = {}) => {
    const fullStyle = getLabelStyleRaw(fieldId, defaultStyles);
    const filtered = { ...defaultStyles };
    if (fullStyle.fontSize) filtered.fontSize = fullStyle.fontSize;
    if (fullStyle.fontWeight) filtered.fontWeight = fullStyle.fontWeight;
    if (fullStyle.fontStyle) filtered.fontStyle = fullStyle.fontStyle;
    if (fullStyle.fontFamily) filtered.fontFamily = fullStyle.fontFamily;
    return filtered;
  };

  const getInputStyle = (fieldId, defaultStyles = {}) => {
    const fullStyle = getInputStyleRaw(fieldId, defaultStyles);
    const filtered = { ...defaultStyles };
    if (fullStyle.fontSize) filtered.fontSize = fullStyle.fontSize;
    if (fullStyle.fontWeight) filtered.fontWeight = fullStyle.fontWeight;
    if (fullStyle.fontStyle) filtered.fontStyle = fullStyle.fontStyle;
    if (fullStyle.fontFamily) filtered.fontFamily = fullStyle.fontFamily;
    return filtered;
  };

  useEffect(() => {
    const loadGridSettings = async () => {
      if (!dbCode || !vType) return;

      // Check Local Storage first
      let cached = localStorage.getItem(`grid_design_${vType}`);
      if (cached) {
        try {
          const parsed = JSON.parse(cached);
          const itemNameCol = parsed.find((c) => c.columnName === "ItemName");
          if (itemNameCol && itemNameCol.width !== 75) {
            localStorage.removeItem(`grid_design_${vType}`);
            cached = null;
          } else {
            setGridColumns(parsed);
            return;
          }
        } catch (e) {
          console.error("Error parsing cached grid settings:", e);
        }
      }

      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/griddesign/${dbCode}/${vType}`,
        );
        const dbCols = response.data.recordset || response.data || [];
        if (dbCols.length > 0) {
          const merged = defaultPurchaseGridColumns.map((initCol) => {
            const dbMatch = dbCols.find(
              (c) =>
                String(c.ColName).toLowerCase() ===
                String(initCol.columnName).toLowerCase(),
            );
            if (dbMatch) {
              return {
                ...initCol,
                width: dbMatch.Width !== null ? dbMatch.Width : initCol.width,
                orderNo: dbMatch.InNo !== null ? dbMatch.InNo : initCol.orderNo,
                header: dbMatch.Header || initCol.header,
                show: dbMatch.Vis === 1,
                textBox: dbMatch.TextBox || initCol.textBox,
                label: dbMatch.Label || initCol.label,
                tabStop:
                  dbMatch.TabStop !== null ? dbMatch.TabStop : initCol.tabStop,
              };
            }
            return initCol;
          });
          merged.sort((a, b) => a.orderNo - b.orderNo);

          // Save to local storage on successful fetch
          localStorage.setItem(`grid_design_${vType}`, JSON.stringify(merged));

          setGridColumns(merged);
        }
      } catch (error) {
        console.error("Error loading grid settings:", error);
      }
    };
    loadGridSettings();
  }, [dbCode, apiBaseUrl, vType]);

  const getColWidth = (colName) => {
    const col = gridColumns.find((c) => c.columnName === colName);
    return col && col.show ? col.width : 0;
  };



  const handleRefresh = async () => {
    setIsRefreshing(true);
    handleClear();
    try {
      await Promise.all([
        fetchPEntryno(),
        fetchSchCurrentRate(),
        fetchfirstandlast(),
        fetchLocationOpts(),
        fetchCashORsupplier(),
        fetchsalemanName(),
        fetchProductDetails(),
        fetchPAcc(),
        fetchCABA(),
        fetchModelOpts(),
      ]);
    } catch (error) {
      console.error("Error refreshing purchase entry data:", error.message);
    }
    setTimeout(() => {
      setIsRefreshing(false);
    }, 600);
  };

  useEffect(() => {
    const obj = GeneralSettings.filter(
      (item) => item.Name === "DECIMAL POINT ",
    );
    if (obj.length > 0 && obj[0].s_Value) {
      setDecimal(parseInt(obj[0].s_Value));
    }
  }, [GeneralSettings]);

  useEffect(() => {
    setfrmid(parseInt(formId));
    setfname(formName);
    setVType(voucherType || formName);
  }, [formId, formName, voucherType]);
  const [locationOpts, setLocationOpts] = useState([]);

  const fetchLocationOpts = async () => {
    if (!dbCode) return;
    try {
      const response = await axios.get(
        `${apiBaseUrl}/otherregistration/getoptions/${dbCode}`,
      );
      if (Array.isArray(response.data)) {
        const locations = response.data
          .filter(
            (rec) =>
              String(rec.Type || rec.type || "").toLowerCase() === "location",
          )
          .map((rec) => ({
            label: rec.Name || rec.name || "",
            value: Number(rec.Auto ?? rec.auto ?? rec.SlNo ?? rec.slno ?? 0) || rec.Name || rec.name || "",
          }));
        setLocationOpts(locations);

        const targetId = activeLocation?.id || sessionStorage.getItem("loginLocationId") || localStorage.getItem("loginLocationId");
        const targetName = activeLocation?.name || sessionStorage.getItem("loginLocation") || localStorage.getItem("loginLocation");
        if (locations.length > 0) {
          const match = targetId
            ? locations.find((l) => Number(l.value) === Number(targetId) || String(l.label).toLowerCase() === String(targetName).toLowerCase())
            : null;
          const chosen = match || locations[0];
          setpurchaseInfoData((prev) => (!prev.locationId ? { ...prev, locationId: chosen.value, locationName: chosen.label } : prev));
        }
      }
    } catch (error) {
      console.error("Error fetching location options:", error.message);
    }
  };

  const [modelOpts, setModelOpts] = useState([]);

  const fetchModelOpts = async () => {
    if (!dbCode) return;
    try {
      const response = await axios.get(`${apiBaseUrl}/model/selectall/${dbCode}`);
      if (response.data && Array.isArray(response.data)) {
        setModelOpts(response.data.map((m) => ({ value: m.Auto, label: m.ModelName })));
      }
    } catch (error) {
      console.error("Error fetching model options:", error.message);
    }
  };

  const [editDisabled, setEditDisabled] = useState(true);
  const [deleteDisabled, setDeleteDisabled] = useState(true);
  const [saveDisabled, setSaveDisabled] = useState(false);
  const [dataFound, setDataFound] = useState(false);
  const [showFindDialog, setShowFindDialog] = useState(false);
  const [findEntryNo, setFindEntryNo] = useState("");

  //console.log("findEntryNo==", findEntryNo)

  const openFindDialog = () => {
    setShowFindDialog(true);
  };

  const closeFindDialog = () => {
    setShowFindDialog(false);
    setFindEntryNo("");
  };
  const [fNl, setfNl] = useState("");

  const { agentCode } = useContext(AuthContext);
  // //console.log("agentCode==", agentCode);

  // initial fetches
  useEffect(() => {
    fetchPEntryno();
    //  current focus
    if (cashSupplierInputRef.current) {
      cashSupplierInputRef.current.focus();
    }

    fetchSchCurrentRate();
    fetchfirstandlast();
    fetchLocationOpts();
    fetchModelOpts();
  }, [apiBaseUrl, frmId, fyid, dbCode]);

  const fetchfirstandlast = async () => {
    if (!dbCode || !formId || !fyid) return;
    try {
      const response = await axios.get(
        `${apiBaseUrl}/purchase/firstandlast/${parseInt(formId)}/${fyid}/${dbCode}`,
      );

      const data = response.data;
      //console.log("first and last", data);

      if (Array.isArray(data) && data.length > 0) {
        setFirstEntryNo(data[0].FirstEntryNo || data[0].firstEntry || null);
        setLastEntryNo(data[0].LastEntryNo || data[0].lastEntry || null);
      }
    } catch (error) {
      console.error("Error fetching first and last no:", error.message);
    }
  };

  const addRow = () => {
    setTableData([...tableData, {}]);
  };
  const combo1opts = [
    [1, "aswin", 999999999, 98765433],
    [2, "sinan", 9876543210, "ab123"],
  ];

  const handleScroll = () => {
    const tableContainer = tableContainerRef.current;
    if (
      tableContainer.scrollTop + tableContainer.clientHeight >=
      tableContainer.scrollHeight - 1
    ) {
      // User has scrolled to the bottom, add new rows
      addRow();
    }
  };

  const handleCellChange = (event, rowIndex, field) => {
    setpurchaseInfoData({
      ...purchaseInfoData,
      roundOff: "",
    });
    const value = event.target ? event.target.value : event;
    const newData = [...tableData];
    newData[rowIndex] = { ...newData[rowIndex], [field]: value };

    PurchaseTableCalculations(newData[rowIndex], purchaseInfoData.taxType);

    setTableData(newData);
  };

  const getCurrentDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedToday = `${year}-${month}-${day}`;
    // Clamp to active FY limits
    if (minDate && formattedToday < minDate) return minDate;
    if (maxDate && formattedToday > maxDate) return maxDate;
    return formattedToday;
  };

  const initialDateVal = getCurrentDate();

  //////////////////////////forms Datas /////////////////////////

  const [tableData, setTableData] = useState([
    ...Array.from({ length: 15 }, () => ({
      ItemCodeId: "",
      ItemCodeLabel: "",
      ProductNameId: "",
      ProductNameLabel: "",
      ModelNameId: "",
      ModelNameLabel: "",
      RateGm: "",
      Qty: "",
      GrWt: "",
      StoneWt: "",
      MudLess: "",
      WstgGm: "",
      NetWeight: "",
      Touchperc: "",
      Divperc: "",
      thangam: "",
      StoneAmt: "",
      Mc: "",
      GrossValue: "",
      NetAmount: "",
      CGST: "",
      SGST: "",
      IGST: "",
      cgstPerc: 0,
      sgstPerc: 0,
      igstPerc: 0,
      TotalAmount: "",
      lessWt: "",
      lessPerc: "",
    })),
  ]);
  //console.log("table data = ", tableData);

  const [purchaseInfoData, setpurchaseInfoData] = useState({
    EntryNo: "",
    poNo: "",
    taxType: 1,
    cashorSupplier: [4, "CASH"],
    supplierName: "",
    supplierInvoNo: "",
    amount: "",
    date: initialDateVal,
    invoDate: initialDateVal,
    purchaseAccId: 12,
    purchaseAccName: "GENERAL PURCHASE A/C",
    typeId: 1,
    typeName: "PURCHASE",
    ob: "",
    salesmanId: "",
    salesmanName: "",
    locationId: activeLocation?.id || sessionStorage.getItem("loginLocationId") || localStorage.getItem("loginLocationId") || "",
    locationName: activeLocation?.name || sessionStorage.getItem("loginLocation") || localStorage.getItem("loginLocation") || "",
    totalQty: "",
    totalGrWt: "",
    totalStonewt: "",
    totalMudless: "",
    totalNetwt: "",
    totalMc: "",
    totalWstg: "",
    totalStAmt: "",
    totalGrossValue: "",
    totalCgst: "",
    totalSgst: "",
    totalIgst: "",
    itemsTotalAmount: "",
    cashPaid: "",
    cashAccId: 4,
    cashAccName: "CASH",
    totalPureWt: "",
    totalLess: "",
    tdsPerc: "",
    tdsAmount: "",
    cess: "",
    otherCharge: "",
    discount: "",
    currentBalance: "",
    roundOff: "",
    grandTotal: "",
    ow: "",
    currentWeight: "",
    exchangeNo: "",
    exchangeAmount: "",
    returnNo: "",
    returnAmount: "",
    totalNetAmount: "",
    printOB: false,
  });

  //console.log("puchaseinfoData ==", purchaseInfoData);

  /////////////////////////////////////////////////////////

  const onRadioChange = (e) => {
    setValue(e.target.value);

    setpurchaseInfoData({
      ...purchaseInfoData,
      taxType: e.target.value,
    });
  };
  /////tab functions//////

  const [activeTab, setActiveTab] = useState("default");

  //////////////////sample Datas/////////////////////

  const names = [
    "Aswin",
    "Vishnu",
    "Saneen",
    "dsdsd",
    "sadr3e",
    "qwwerew",
    "sdfghj",
    "dfghjk",
    "wesdcvhj",
    "uaguahuahsu",
    "sssssssssssssssssss",
  ];

  const SnameRef = useRef(null);
  const PaccRef = useRef(null);

  ///////Refs///Navigation////

  const entryNoInputRef = useRef(null);
  const PoNoInputRef = useRef(null);
  const TaxInputRef = useRef(null);
  const NontaxInputRef = useRef(null);
  const cashSupplierInputRef = useRef(null);
  const supplierNameInputRef = useRef(null);
  const supplierInVoNoInputRef = useRef(null);
  const searchBtnInputRef = useRef(null);
  const amountInputRef = useRef(null);
  const dateInputRef = useRef(null);
  const invoDateInputRef = useRef(null);
  const detailsBtnInputRef = useRef(null);
  const purchaseAcInputRef = useRef(null);
  const typeInputRef = useRef(null);
  const obInputRef = useRef(null);
  const salesManInputRef = useRef(null);
  const locationInputRef = useRef(null);
  const ItemCodeInputRef = useRef(null);
  const lesspercInputRef = useRef(null);
  const lesswtInputRef = useRef(null);
  const editItembtnRef = useRef(null);
  const removeItembtnRef = useRef(null);
  const otherChargesInputRef = useRef(null);
  const discountInputRef = useRef(null);
  const roundOffInputRef = useRef(null);
  // Flag to skip grandTotal recalculation during entry load (prevents race condition
  // where tableData useEffect fires before roundOff state from loadEntryData commits)
  const isLoadingEntryRef = useRef(false);
  const cashPaidInputRef = useRef(null);
  const cashAccInputRef = useRef(null);

  const owInputRef = useRef(null);
  const saveButtonInputRef = useRef(null);

  

  const handleKeyDown = (event, currentFieldIdOrNextRef) => {
    if (event.key === "Enter" || event.key === "Tab") {
      event.preventDefault();
      if (typeof currentFieldIdOrNextRef === "string") {
        handleDynamicKeyDown(event, currentFieldIdOrNextRef);
      } else if (currentFieldIdOrNextRef && currentFieldIdOrNextRef.current) {
        currentFieldIdOrNextRef.current.focus();
      }
    }
  };
  const validatePurchaseRow = (rowIndex) => {
    const row = tableData[rowIndex];
    if (!row) return false;
    if (
      row.GrWt === "" ||
      row.GrWt == 0 ||
      row.Qty === "" ||
      row.Qty == 0
    ) {
      alert("Enter Data Correctly");
      return false;
    }
    return true;
  };

  const [RowIndex, setRowIndex] = useState(0);

  const handleKeyDownTable = (event, rowIndex, columnIndex) => {
    const visibleCols = gridColumns.filter((c) => c.show);
    const col = visibleCols[columnIndex];
    if (col) {
      handleDynamicKeyDown(event, `grid_${rowIndex}_${col.columnName}`);
    }
    setRowIndex(rowIndex);
  };
  const [typeOpts, setTypeOpts] = useState([
    { value: 1, label: "PURCHASE" },
    { value: 2, label: "INTERSTATE" },
  ]);

  const [purchasecashorsuppl, setpurchasecashorsuppl] = useState([]);

  const fetchCashORsupplier = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/common/cashOrSupplier/${dbCode}`,
      );
      const cashorsuppl = response.data;
      const transformedData = cashorsuppl.map((item) => [
        item.Ledcode,
        item.LedName,
        item.Mobile,
        item.lh_name,
      ]);
      setpurchasecashorsuppl(transformedData);
    } catch (error) {
      console.error("Error fetching cashorsuppl Values:", error.message);
    }
    backtrackfocus();
  };

  useEffect(() => {
    fetchCashORsupplier();
    const socket = io(apiBaseUrl); // Make sure the URL matches your backend server
    socket.on("PurchaseUpdated", () => {
      fetchCashORsupplier();
    });
    socket.on("LedgerUpdated", () => {
      fetchCashORsupplier();
    });

    return () => {
      socket.disconnect(); // Clean up the socket connection on component unmount
    };
  }, [apiBaseUrl]);

  const [salesmanOpts, setSalesmanOpts] = useState([]);

  const fetchsalemanName = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/common/selectAllSalesMan/${dbCode}`,
      );
      const salesmanData = response.data;
      const sNames = salesmanData.map((item) => ({
        value: item.Auto,
        label: item.Name,
      }));
      setSalesmanOpts(sNames);
    } catch (error) {
      console.error("Error fetching names Values:", error.message);
    }
  };

  useEffect(() => {
    fetchsalemanName();
  }, []);

  const [pDetails, setpDetails] = useState([]);
  const [pNames, setpNames] = useState([]);
  const [pCode, setpCode] = useState([]);

  const fetchProductDetails = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/selectallProduct/${dbCode}`,
      );
      const productDet = response.data;
      const PNames = productDet.map((item) => ({
        value: item.slNo,
        label: item.itemName,
      }));
      const pItemCode = productDet.map((item) => ({
        value: item.slNo,
        label: item.itemCode,
      }));
      setpNames(PNames);
      setpCode(pItemCode);
      setpDetails(productDet);
      backtrackfocusTable();
    } catch (error) {
      console.error("Error fetching names Values:", error.message);
    }
  };

  useEffect(() => {
    fetchProductDetails();
    const socket = io(apiBaseUrl); // Make sure the URL matches your backend server
    socket.on("ProductUpdated", () => {
      fetchProductDetails();
    });

    return () => {
      socket.disconnect(); // Clean up the socket connection on component unmount
    };
  }, [apiBaseUrl]);

  const fetchProductRateFromApi = async (productId, targetDate) => {
    try {
      const dateToUse = targetDate || purchaseInfoData.date;
      const response = await axios.get(
        `${apiBaseUrl}/main/getProductClassRate/${dbCode}?productId=${productId}&date=${dateToUse || ""}`,
      );
      return response.data?.currentRate || 0;
    } catch (error) {
      console.error("Error fetching gold rate for product:", productId, error.message);
      return 0;
    }
  };

  const recalculateTableRatesForDate = async (targetDate) => {
    if (!tableData || tableData.length === 0) return;
    const dateToUse = targetDate || purchaseInfoData.date;
    let changed = false;
    const updatedTable = await Promise.all(tableData.map(async (row) => {
      if (row.ProductNameId || row.ItemCodeId) {
        const pId = row.ProductNameId || row.ItemCodeId;
        const fetchedRate = await fetchProductRateFromApi(pId, dateToUse);
        const updatedRow = {
          ...row,
          RateGm: fetchedRate
        };
        PurchaseTableCalculations(
          updatedRow,
          purchaseInfoData.taxType,
          purchaseInfoData.typeName,
        );
        changed = true;
        return updatedRow;
      }
      return row;
    }));
    if (changed) {
      setTableData(updatedTable);
    }
  };

  const fetchTaxgroup = async (rowIndex, productId) => {
    const newData = [...tableData];
    const selectedProduct = pDetails.find(
      (product) => product.slNo === productId,
    );
    if (selectedProduct) {
      const fetchedRate = await fetchProductRateFromApi(productId, purchaseInfoData.date);
      newData[rowIndex] = {
        ...newData[rowIndex],
        ProductNameId: selectedProduct.slNo,
        ProductNameLabel: selectedProduct.itemName,
        ItemCodeId: selectedProduct.slNo,
        ItemCodeLabel: selectedProduct.itemCode,
        cgstPerc: selectedProduct.cgst,
        sgstPerc: selectedProduct.sgst,
        igstPerc: selectedProduct.igst,
        RateGm: fetchedRate,
      };
      PurchaseTableCalculations(
        newData[rowIndex],
        purchaseInfoData.taxType,
        purchaseInfoData.typeName,
      );
    }
    setTableData(newData);
  };

  const [srlNo, setsrlNo] = useState(null);

  const handleClear = () => {
    setTableData([
      ...Array.from({ length: 15 }, () => ({
        ItemCodeId: "",
        ItemCodeLabel: "",
        ProductNameId: "",
        ProductNameLabel: "",
        ModelNameId: "",
        ModelNameLabel: "",
        RateGm: "",
        Qty: "",
        GrWt: "",
        StoneWt: "",
        MudLess: "",
        WstgGm: "",
        NetWeight: "",
        Touchperc: "",
        Divperc: "",
        thangam: "",
        StoneAmt: "",
        Mc: "",
        GrossValue: "",
        CGST: "",
        SGST: "",
        IGST: "",
        cgstPerc: 0,
        sgstPerc: 0,
        igstPerc: 0,
        TotalAmount: "",
        lessWt: "",
        lessPerc: "",
      })),
    ]);
    setpurchaseInfoData({
      poNo: "",
      taxType: 1,
      cashorSupplier: [4, "CASH"],
      supplierName: "",
      supplierInvoNo: "",
      amount: "",
      date: getCurrentDate(),
      invoDate: getCurrentDate(),
      purchaseAccId: 12,
      purchaseAccName: "GENERAL PURCHASE A/C",
      typeId: 1,
      typeName: "PURCHASE",
      ob: "",
      salesmanId: "",
      salesmanName: "",
      locationId: activeLocation ? activeLocation.id : (localStorage.getItem("loginLocationId") || ""),
      locationName: activeLocation ? activeLocation.name : (localStorage.getItem("loginLocation") || ""),
      totalQty: "",
      totalGrWt: "",
      totalStonewt: "",
      totalMudless: "",
      totalNetwt: "",
      totalMc: "",
      totalWstg: "",
      totalStAmt: "",
      totalGrossValue: "",
      totalCgst: "",
      totalSgst: "",
      totalIgst: "",
      itemsTotalAmount: "",
      cashPaid: "",
      cashAccId: 4,
      cashAccName: "CASH",
      totalPureWt: "",
      totalLess: "",
      tdsPerc: "",
      tdsAmount: "",
      cess: "",
      otherCharge: "",
      discount: "",
      currentBalance: "",
      roundOff: "",
      grandTotal: "",
      exchangeNo: "",
      exchangeAmount: "",
      returnNo: "",
      returnAmount: "",
    });
    setRowIndex(0);

    fetchPEntryno();
    setSaveDisabled(false);
    setDataFound(false);
    setCurrentEntryNo(null);
    fetchfirstandlast();
    triggerInitialFocus();
  };

  useEffect(() => {
    // Guard: skip GST recalculation while loadEntryData is in progress.
    // When loading, taxType is set as part of the load — we don't want to
    // retrigger table recalculation which would chain into a grandTotal wipe.
    if (isLoadingEntryRef.current) return;
    let changed = false;
    const newData = tableData.map((row) => {
      if (row.ProductNameId || row.ItemCodeId) {
        const updatedRow = { ...row };
        PurchaseTableCalculations(
          updatedRow,
          purchaseInfoData.taxType,
          purchaseInfoData.typeName,
        );
        changed = true;
        return updatedRow;
      }
      return row;
    });
    if (changed) {
      setTableData(newData);
    }
  }, [purchaseInfoData.typeName, purchaseInfoData.taxType]);

  const [currentGoldRate, setCurrentGoldRate] = useState(0);

  const fetchSchCurrentRate = async (targetDate) => {
    try {
      const dateToUse = targetDate || purchaseInfoData.date;
      const response = await axios.get(
        `${apiBaseUrl}/main/getGoldRate/${dbCode}?date=${dateToUse || ""}`,
      );
      const currentrate = response.data[0]?.currentRate;
      setCurrentGoldRate(currentrate || 0);
    } catch (error) {
      console.error("Error fetching gold rate Values:", error.message);
      setCurrentGoldRate(0);
    }
  };

  useEffect(() => {
    // Skip rate recalculation when loading a saved entry — the loaded rates
    // are already correct from DB; recalculating by date would overwrite them
    // and trigger a tableData change that wipes roundOff.
    if (isLoadingEntryRef.current) return;
    fetchSchCurrentRate(purchaseInfoData.date);
    recalculateTableRatesForDate(purchaseInfoData.date);
  }, [apiBaseUrl, dbCode, purchaseInfoData.date]);

  ////////////////total wt calculations/////////////////////////////

  useEffect(() => {
    let totalQty = 0;
    let totalGrWt = 0;
    let totalStonewt = 0;
    let totalMudless = 0;
    let totalNetwt = 0;
    let totalMc = 0;
    let totalWstg = 0;
    let totalStAmt = 0;
    let totalGrossValue = 0;
    let totalCgst = 0;
    let totalSgst = 0;
    let totalIgst = 0;
    let itemsTotalAmount = 0;
    let totalPureWt = 0;
    let totalLessWt = 0;
    let totalNetAmount = 0;

    tableData.forEach((rowData) => {
      totalQty += parseFloat(rowData.Qty || 0.0);
      totalGrWt += parseFloat(rowData.GrWt || 0.0);
      totalStonewt += parseFloat(rowData.StoneWt || 0.0);
      totalMudless += parseFloat(rowData.MudLess || 0.0);
      totalNetwt += parseFloat(rowData.NetWeight || 0.0);
      totalMc += parseFloat(rowData.Mc || 0.0);
      totalWstg += parseFloat(rowData.WstgGm || 0.0);
      totalStAmt += parseFloat(rowData.StoneAmt || 0.0);
      totalGrossValue += parseFloat(rowData.GrossValue || 0.0);
      totalCgst += parseFloat(rowData.CGST || 0.0);
      totalSgst += parseFloat(rowData.SGST || 0.0);
      totalIgst += parseFloat(rowData.IGST || 0.0);
      itemsTotalAmount += parseFloat(rowData.TotalAmount || 0.0);
      totalPureWt += parseFloat(rowData.thangam || 0.0);
      totalLessWt += parseFloat(rowData.lessWt || 0.0);
      totalNetAmount += parseFloat(rowData.NetAmount || 0.0);
    });

    setpurchaseInfoData((prevState) => ({
      ...prevState,
      totalQty: totalQty.toFixed(decimal), // Update total
      totalGrWt: totalGrWt.toFixed(decimal),
      totalStonewt: totalStonewt.toFixed(decimal),
      totalMudless: totalMudless.toFixed(decimal),
      totalNetwt: totalNetwt.toFixed(decimal),
      totalMc: totalMc.toFixed(decimal),
      totalWstg: totalWstg.toFixed(decimal),
      totalStAmt: totalStAmt.toFixed(decimal),
      totalGrossValue: totalGrossValue.toFixed(decimal),
      totalCgst: totalCgst.toFixed(decimal),
      totalSgst: totalSgst.toFixed(decimal),
      totalIgst: totalIgst.toFixed(decimal),
      itemsTotalAmount: itemsTotalAmount.toFixed(decimal),
      totalPureWt: totalPureWt.toFixed(decimal),
      totalLess: totalLessWt.toFixed(decimal),
      totalNetAmount: totalNetAmount.toFixed(decimal),
    }));
  }, [tableData]);

  ////////////////////calculation///////////////////

  const PurchaseTableCalculations = (row, taxType, passedTransType) => {
    const grWt = parseFloat(row.GrWt || 0);
    const stoneWt = parseFloat(row.StoneWt || 0);
    const mudLess = parseFloat(row.MudLess || 0);
    const wstgGm = parseFloat(row.WstgGm || 0);
    const lessPerc = parseFloat(row.lessPerc || 0);
    const rate = parseFloat(row.RateGm || 0);
    const cgstPerc = parseFloat(row.cgstPerc || 0);
    const sgstPerc = parseFloat(row.sgstPerc || 0);
    const igstPerc = parseFloat(row.igstPerc || 0);
    const mc = parseFloat(row.Mc || 0);
    const stAmnt = parseFloat(row.StoneAmt || 0);

    ///caluculate LessWt///

    const lessWt = (grWt * lessPerc) / 100;

    row.lessWt = lessWt.toFixed(decimal);

    ///caluculate NetWt///
    if (stoneWt + mudLess + lessWt > grWt) {
      alert("Total Deduction More Than Gross Weight");
      return;
    }

    const netWt = (grWt - stoneWt - mudLess - lessWt + wstgGm).toFixed(decimal);

    row.NetWeight = netWt;

    ///caluculate Thangam///

    if (row.NetWeight !== "") {
      const thangam = (
        (netWt * row.Touchperc) /
        (row.Divperc ? row.Divperc : 1)
      ).toFixed(decimal);

      row.thangam = thangam;
    }

    ///caluculate GrossValue/////

    const GrossValue = (
      rate * netWt +
      parseFloat(mc) +
      parseFloat(stAmnt)
    ).toFixed(decimal);

    if (row.RateGm !== "" && row.GrWt !== "") {
      row.GrossValue = GrossValue;
    }

    /// Calculate GST Amounts based on Type and taxType /////
    const transType = passedTransType || purchaseInfoData.typeName;

    const isTaxable = taxType === 1 || taxType === "Tax";

    if (!isTaxable) {
      row.CGST = (0).toFixed(decimal);
      row.SGST = (0).toFixed(decimal);
      row.IGST = (0).toFixed(decimal);
    } else if (transType === "INTERSTATE") {
      row.IGST = ((GrossValue * igstPerc) / 100).toFixed(decimal);
      row.CGST = (0).toFixed(decimal);
      row.SGST = (0).toFixed(decimal);
    } else {
      row.CGST = ((GrossValue * cgstPerc) / 100).toFixed(decimal);
      row.SGST = ((GrossValue * sgstPerc) / 100).toFixed(decimal);
      row.IGST = (0).toFixed(decimal);
    }

    /// NetAmount (GrossValue - Mc - StoneAmt)/////
    const NetAmount = (GrossValue - mc - stAmnt).toFixed(decimal);
    row.NetAmount = NetAmount;

    ///Total Amount /////

    const TotalAmount =
      parseFloat(row.GrossValue) +
      parseFloat(row.CGST || 0) +
      parseFloat(row.SGST || 0) +
      parseFloat(row.IGST || 0);

    row.TotalAmount = TotalAmount.toFixed(decimal);
  };

  /////////////////////////////grand Total//////////////////////
  useEffect(() => {
    // Skip recalculation while loadEntryData is populating state.
    // During a load, tableData changes fire this chain before roundOff commits,
    // causing grandTotal to be computed without roundOff. The loaded grandTotal
    // is already correct from the DB — trust it instead.
    if (isLoadingEntryRef.current) return;

    setpurchaseInfoData((prevState) => {
      const tableTotal = parseFloat(prevState.itemsTotalAmount) || 0;
      const otherCharges = parseFloat(prevState.otherCharge) || 0;
      const cess = parseFloat(prevState.cess) || 0;
      const disc = parseFloat(prevState.discount) || 0;
      const roundOff = parseFloat(prevState.roundOff) || 0;
      const GrandTotal = tableTotal + otherCharges + cess - disc + roundOff;
      const newGrandTotal = GrandTotal.toFixed(decimal);
      // Skip update if value hasn't changed to prevent infinite loops
      if (prevState.grandTotal === newGrandTotal) return prevState;
      return { ...prevState, grandTotal: newGrandTotal };
    });
  }, [
    purchaseInfoData.itemsTotalAmount,
    purchaseInfoData.cess,
    purchaseInfoData.otherCharge,
    purchaseInfoData.discount,
    purchaseInfoData.roundOff,
    decimal,
  ]);

  ///////////////////////////////////validations//////////////////////////

  const handleCheckSupplier = (e) => {
    // ////////////////////console.log('regcustom',AcNames);
    //////////////console.log("suppl function called");

    const targetValue = e.target.value;
    const isValuePresent = purchasecashorsuppl.some(
      (item) => item[1] === targetValue,
    );

    if (!isValuePresent && e.target.value !== "") {
      if (!window.confirm("Account Does Not Exist,Create New..?")) {
        return;
      }
      Open(e, cashSupplierInputRef);
    }
  };
  const focusedInputRef = useRef(null);
  const handleCheckProductList = (e, rowIndex, columnIndex, type) => {
    // //////////////////console.log('regcustom',AcNames);

    const targetValue = e.target.value;

    ////////////console.log("targetValue===",targetValue);

    const checkArray = type === "itemCode" ? pCode : pNames;
    const isValuePresent = checkArray.some(
      (item) => item.label === targetValue,
    );

    if (!isValuePresent && e.target.value !== "") {
      if (!window.confirm("Product Does not Exists,Create New..?")) {
        return;
      } else {
        focusedInputRef.current = e.target;
        OpenPReg(e, rowIndex, columnIndex, type);
      }
    }
  };

  useEffect(() => {
    if (focusedInputRef.current) {
      focusedInputRef.current.focus();
      focusedInputRef.current = null; // Reset the reference
    }
  }, [pNames]); // Trigger this effect when pNames changes

  const backtrackfocus = () => {
    const ref = sessionStorage.getItem("returnInputRef");

    if (ref) {
      cashSupplierInputRef.current.focus();
    }

    sessionStorage.removeItem("returnInputRef");
  };

  const backtrackfocusTable = () => {
    const rowIndex = sessionStorage.getItem("tableRowIndex");

  };

  const roundoff = () => {
    const grandTotal = parseFloat(purchaseInfoData.grandTotal);

    // //////////console.log("rounded value===", Math.round(grandTotal));

    const roundedValue = Math.round(grandTotal) - grandTotal;

    setpurchaseInfoData({
      ...purchaseInfoData,
      roundOff: roundedValue.toFixed(decimal),
    });
  };

  const fetchPEntryno = async () => {
    if (!dbCode || !formId || !fyid) return;
    try {
      const response = await axios.get(
        `${apiBaseUrl}/purchase/p_entryno/${formId}/${fyid}/${dbCode}`,
      );
      const purchaseentryNo = response.data;

      setpurchaseInfoData((prevData) => ({
        ...prevData,
        EntryNo: purchaseentryNo,
      }));
      // setSchEntryNo(schemeentryNo[0] );
    } catch (error) {
      console.error("Error fetching Pentry no:", error.message);
    }
  };
  useEffect(() => {
    if (!dbCode || !formId || !fyid) return;
    fetchPEntryno();

    const socket = io(apiBaseUrl);
    socket.on("PurchaseUpdated", () => {
      fetchPEntryno();
    });

    return () => {
      socket.disconnect();
    };
  }, [apiBaseUrl, dbCode, formId, fyid]);

  const [pAcc, setPacc] = useState([]);

  const fetchPAcc = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/common/selectAllPurchaseAcc/${dbCode}`,
      );
      const pacc = response.data;

      // Transforming the array into the desired format

      const transformedData = pacc.map((item) => ({
        value: item.Ledcode,
        label: item.LedName,
      }));
      setPacc(transformedData);
    } catch (error) {
      console.error("Error fetching PAcc no:", error.message);
    }
  };
  useEffect(() => {
    fetchPAcc();
  }, [apiBaseUrl]);

  const [caba, setcaba] = useState([]);

  const fetchCABA = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/common/selectCashAndBank/${dbCode}`,
      );
      const CABA = response.data;

      // Transforming the array into the desired format

      const transformedData = CABA.map((item) => ({
        value: item.ledcode,
        label: item.LedName,
      }));
      setcaba(transformedData);
    } catch (error) {
      console.error("Error fetching PAcc no:", error.message);
    }
  };
  useEffect(() => {
    fetchCABA();
  }, [apiBaseUrl]);

  const fetchSupplierOB = async (supplierId) => {
    if (!supplierId) return;
    try {
      const response = await axios.get(
        `${apiBaseUrl}/common/supplierOB/${dbCode}`,
        {
          params: {
            supplierId: supplierId,
            date: purchaseInfoData.date,
            fyId: fyid,
          },
        },
      );
      if (response.data.success) {
        setpurchaseInfoData((prev) => ({
          ...prev,
          ob: response.data.balance.toFixed(decimal),
          ow: response.data.weight.toFixed(decimal),
        }));
      } else {
        setpurchaseInfoData((prev) => ({
          ...prev,
          ob: "0.00",
          ow: "0.00",
        }));
      }
    } catch (error) {
      console.error("Error fetching supplier OB:", error.message);
      setpurchaseInfoData((prev) => ({
        ...prev,
        ob: "0.00",
        ow: "0.00",
      }));
    }
  };

  // Trigger fetch when supplier or date changes
  useEffect(() => {
    const supplierId = Array.isArray(purchaseInfoData.cashorSupplier)
      ? purchaseInfoData.cashorSupplier[0]
      : purchaseInfoData.cashorSupplier;

    if (supplierId && purchaseInfoData.date) {
      fetchSupplierOB(supplierId);
    }
  }, [purchaseInfoData.cashorSupplier, purchaseInfoData.date]);

  useEffect(() => {
    const ob = parseFloat(purchaseInfoData.ob || 0);
    const ow = parseFloat(purchaseInfoData.ow || 0);
    const grandTotal = parseFloat(purchaseInfoData.grandTotal || 0);
    const totalPureWt = parseFloat(purchaseInfoData.totalPureWt || 0);

    // Current Balance = Old Balance + Bill Total
    const currentBal = (ob + grandTotal).toFixed(decimal);
    // Current Weight = Old Weight + Bill Pure Weight
    const currentWt = (ow + totalPureWt).toFixed(decimal);

    setpurchaseInfoData((prev) => ({
      ...prev,
      currentBalance: currentBal,
      currentWeight: currentWt,
    }));
  }, [
    purchaseInfoData.ob,
    purchaseInfoData.ow,
    purchaseInfoData.grandTotal,
    purchaseInfoData.totalPureWt,
  ]);

  useEffect(() => {
    if (purchaseInfoData.cashorSupplier && purchaseInfoData.EntryNo) {
      const supplierId = Array.isArray(purchaseInfoData.cashorSupplier)
        ? purchaseInfoData.cashorSupplier[0]
        : purchaseInfoData.cashorSupplier;

      if (supplierId && supplierId !== 0) {
        fetchSupplierOB(supplierId, purchaseInfoData.EntryNo);
      }
    }
  }, [purchaseInfoData.EntryNo]);

  // Update current entry number when data is loaded
  useEffect(() => {
    if (
      purchaseInfoData.EntryNo &&
      purchaseInfoData.EntryNo !== currentEntryNo
    ) {
      setCurrentEntryNo(purchaseInfoData.EntryNo);
    }
  }, [purchaseInfoData.EntryNo]);

  const handleSave = async () => {
    setSaveDisabled(true);
    setLoading(true);

    try {
      const filteredTableData = tableData.filter((row) => {
        // Only include rows that have a product name or item code
        return row.ProductNameLabel || row.ItemCodeLabel;
      });

      if (filteredTableData.length === 0) {
        alert("Please add at least one item to the purchase.");
        setSaveDisabled(false);
        setLoading(false);
        return;
      }

      const hasIncompleteData = filteredTableData.some((row) => {
        return (
          row.ItemCodeLabel === "" ||
          row.ItemCodeLabel === null ||
          row.ItemCodeLabel === undefined ||
          row.ProductNameLabel === "" ||
          row.ProductNameLabel === null ||
          row.ProductNameLabel === undefined ||
          row.RateGm === "" ||
          row.RateGm === null ||
          row.RateGm === undefined ||
          row.Qty === "" ||
          row.Qty === null ||
          row.Qty === undefined ||
          row.GrWt === "" ||
          row.GrWt === null ||
          row.GrWt === undefined ||
          row.NetWeight === "" ||
          row.NetWeight === null ||
          row.NetWeight === undefined ||
          row.GrossValue === "" ||
          row.GrossValue === null ||
          row.GrossValue === undefined
        );
      });

      if (hasIncompleteData) {
        alert("Enter Data Correctly in the table.");
        setSaveDisabled(false);
        setLoading(false);
        return;
      }

      if (purchaseInfoData.date && !isDateInFy(purchaseInfoData.date)) {
        alert("Date incompatible with financial year");
        setSaveDisabled(false);
        setLoading(false);
        return;
      }

      // Log currently filled data for debugging
      //console.log("Validating purchaseInfoData:", purchaseInfoData);

      if (
        (!purchaseInfoData.taxType && purchaseInfoData.taxType !== 0) ||
        !purchaseInfoData.cashorSupplier ||
        !purchaseInfoData.purchaseAccId ||
        !purchaseInfoData.typeName ||
        !purchaseInfoData.cashAccId ||
        purchaseInfoData.grandTotal === "" ||
        purchaseInfoData.grandTotal === null ||
        purchaseInfoData.grandTotal === 0
      ) {
        const missing = [];
        if (!purchaseInfoData.taxType && purchaseInfoData.taxType !== 0)
          missing.push("Tax Type");
        if (!purchaseInfoData.cashorSupplier) missing.push("Cash/Supplier");
        if (!purchaseInfoData.purchaseAccId) missing.push("Purchase A/C");
        if (!purchaseInfoData.typeName) missing.push("Type");
        if (!purchaseInfoData.cashAccId) missing.push("Cash A/C");
        if (!purchaseInfoData.grandTotal)
          missing.push("Grand Total (check items)");
        alert("Enter Data Correctly. Missing: " + missing.join(", "));
        setSaveDisabled(false);
        setLoading(false);
        return;
      }

      // Check if manually entered amount matches grand total
      if (purchaseInfoData.amount !== "" && purchaseInfoData.amount != null) {
        if (
          parseFloat(purchaseInfoData.amount) !==
          parseFloat(purchaseInfoData.grandTotal)
        ) {
          alert("Amount and Grand Total must be equal!");
          setSaveDisabled(false);
          setLoading(false);
          return;
        }
      }

      // filteredTableData already calculated above

      // Convert taxType from 1/0 to "Tax"/"NonTax"
      const taxTypeValue = purchaseInfoData.taxType === 1 ? "Tax" : "NonTax";

      const formattedPurchaseInfo = {
        ...purchaseInfoData,
        taxType: taxTypeValue, // This will send "Tax" or "NonTax" instead of 1/0
        amount:
          parseFloat(purchaseInfoData.amount || purchaseInfoData.grandTotal) ||
          0,
        cashorSupplierId: Array.isArray(purchaseInfoData.cashorSupplier)
          ? purchaseInfoData.cashorSupplier[0]
          : purchaseInfoData.cashorSupplier,
        supplierName: Array.isArray(purchaseInfoData.supplierName)
          ? purchaseInfoData.supplierName[1]
          : purchaseInfoData.supplierName,
        purchaseAccId: purchaseInfoData.purchaseAccId,
        typeName: purchaseInfoData.typeName,
        salesmanId: purchaseInfoData.salesmanId,
        locationId: purchaseInfoData.locationId || (activeLocation?.id ? activeLocation.id : (sessionStorage.getItem("loginLocationId") || localStorage.getItem("loginLocationId") || 0)),
        cashAccId: purchaseInfoData.cashAccId,
        ob: parseFloat(purchaseInfoData.ob) || 0,
        totalQty: parseInt(purchaseInfoData.totalQty) || 0,
        totalGrWt: parseFloat(purchaseInfoData.totalGrWt) || 0,
        totalStonewt: parseFloat(purchaseInfoData.totalStonewt) || 0,
        totalMudless: parseFloat(purchaseInfoData.totalMudless) || 0,
        totalNetwt: parseFloat(purchaseInfoData.totalNetwt) || 0,
        totalMc: parseFloat(purchaseInfoData.totalMc) || 0,
        totalWstg: parseFloat(purchaseInfoData.totalWstg) || 0,
        totalStAmt: parseFloat(purchaseInfoData.totalStAmt) || 0,
        totalGrossValue: parseFloat(purchaseInfoData.totalGrossValue) || 0,
        totalCgst: parseFloat(purchaseInfoData.totalCgst) || 0,
        totalSgst: parseFloat(purchaseInfoData.totalSgst) || 0,
        totalIgst: parseFloat(purchaseInfoData.totalIgst) || 0,
        itemsTotalAmount: parseFloat(purchaseInfoData.itemsTotalAmount) || 0,
        cashPaid: parseFloat(purchaseInfoData.cashPaid) || 0,
        totalPureWt: parseFloat(purchaseInfoData.totalPureWt) || 0,
        totalLess: parseFloat(purchaseInfoData.totalLess) || 0,
        tdsPerc: parseFloat(purchaseInfoData.tdsPerc) || 0,
        tdsAmount: parseFloat(purchaseInfoData.tdsAmount) || 0,
        cess: parseFloat(purchaseInfoData.cess) || 0,
        otherCharge: parseFloat(purchaseInfoData.otherCharge) || 0,
        discount: parseFloat(purchaseInfoData.discount) || 0,
        roundOff: parseFloat(purchaseInfoData.roundOff) || 0,
        grandTotal: parseFloat(purchaseInfoData.grandTotal) || 0,
        exchangeAmount: parseFloat(purchaseInfoData.exchangeAmount) || 0,
        returnAmount: parseFloat(purchaseInfoData.returnAmount) || 0,
        totalNetAmount: parseFloat(purchaseInfoData.totalNetAmount) || 0,
        ow: parseFloat(purchaseInfoData.ow) || 0,
        currentWeight: parseFloat(purchaseInfoData.currentWeight) || 0,
        currentBalance: parseFloat(purchaseInfoData.currentBalance) || 0,
      };
      // Format table data numeric values
      const formattedTableData = filteredTableData.map((row) => ({
        ...row,
        ItemCode: row.ItemCodeId,
        ProductName: row.ProductNameId,
        ModelName: row.ModelNameId,
        RateGm: parseFloat(row.RateGm) || 0,
        Qty: parseInt(row.Qty) || 0,
        GrWt: parseFloat(row.GrWt) || 0,
        StoneWt: parseFloat(row.StoneWt) || 0,
        MudLess: parseFloat(row.MudLess) || 0,
        WstgGm: parseFloat(row.WstgGm) || 0,
        NetWeight: parseFloat(row.NetWeight) || 0,
        Touchperc: parseFloat(row.Touchperc) || 0,
        Divperc: parseFloat(row.Divperc) || 0,
        thangam: parseFloat(row.thangam) || 0,
        StoneAmt: parseFloat(row.StoneAmt) || 0,
        Mc: parseFloat(row.Mc) || 0,
        GrossValue: parseFloat(row.GrossValue) || 0,
        CGST: parseFloat(row.CGST) || 0,
        SGST: parseFloat(row.SGST) || 0,
        IGST: parseFloat(row.IGST) || 0,
        TotalAmount: parseFloat(row.TotalAmount) || 0,
        lessWt: parseFloat(row.lessWt) || 0,
        lessPerc: parseFloat(row.lessPerc) || 0,
      }));

      const response = await axios.post(
        `${apiBaseUrl}/purchase/savePurchase/${parseInt(frmId)}/${fyid}/${dbCode}`,
        {
          P_info: formattedPurchaseInfo,
          P_parti: formattedTableData,
          agCode: agentCode,
        },
      );

      if (response.data.success) {
        setLoading(false);

        const newEntryNo = response.data.entryNo;

        setpurchaseInfoData((prev) => ({
          ...prev,
          EntryNo: newEntryNo,
        }));

        alert(`Entry Saved Successfully! Entry No: ${newEntryNo}`);

        // Refresh first and last after save
        fetchfirstandlast();
        fetchPEntryno();

        // handleClear();
      } else {
        setLoading(false);
        alert("Failed to save data!");
        setSaveDisabled(false);
      }
    } catch (error) {
      console.error("Error saving data:", error.message);
      setLoading(false);
      alert("Internal server error!");
      setSaveDisabled(false);
    }
  };

  const handleEdit = async () => {
    if (!currentEntryNo) {
      alert("No entry selected to edit");
      return;
    }

    // Confirm edit
    if (!window.confirm(`Do you want to update Entry No: ${currentEntryNo}?`)) {
      return;
    }

    setEditDisabled(true);
    setSaveDisabled(true);
    setLoading(true);

    try {
      // Filter out empty rows first
      const filteredTableData = tableData.filter((row) => {
        // Only include rows that have a product name or item code
        return row.ProductNameLabel || row.ItemCodeLabel;
      });

      if (filteredTableData.length === 0) {
        alert("Please add at least one item to the purchase.");
        setEditDisabled(false);
        setSaveDisabled(false);
        setLoading(false);
        return;
      }

      // Validate table data based on filtered rows
      const hasIncompleteData = filteredTableData.some((row) => {
        return (
          row.ItemCodeLabel === "" ||
          row.ItemCodeLabel === null ||
          row.ItemCodeLabel === undefined ||
          row.ProductNameLabel === "" ||
          row.ProductNameLabel === null ||
          row.ProductNameLabel === undefined ||
          row.RateGm === "" ||
          row.RateGm === null ||
          row.RateGm === undefined ||
          row.Qty === "" ||
          row.Qty === null ||
          row.Qty === undefined ||
          row.GrWt === "" ||
          row.GrWt === null ||
          row.GrWt === undefined ||
          row.NetWeight === "" ||
          row.NetWeight === null ||
          row.NetWeight === undefined ||
          row.GrossValue === "" ||
          row.GrossValue === null ||
          row.GrossValue === undefined
        );
      });

      if (hasIncompleteData) {
        alert("Please complete all required fields in the table.");
        setEditDisabled(false);
        setSaveDisabled(false);
        setLoading(false);
        return;
      }

      // Log currently filled data for debugging
      //console.log("Validating purchaseInfoData for edit:", purchaseInfoData);

      if (
        (!purchaseInfoData.taxType && purchaseInfoData.taxType !== 0) ||
        !purchaseInfoData.cashorSupplier ||
        !purchaseInfoData.purchaseAccId ||
        !purchaseInfoData.typeName ||
        !purchaseInfoData.cashAccId ||
        purchaseInfoData.grandTotal === "" ||
        purchaseInfoData.grandTotal === null ||
        purchaseInfoData.grandTotal === 0
      ) {
        const missing = [];
        if (!purchaseInfoData.taxType && purchaseInfoData.taxType !== 0)
          missing.push("Tax Type");
        if (!purchaseInfoData.cashorSupplier) missing.push("Cash/Supplier");
        if (!purchaseInfoData.purchaseAccId) missing.push("Purchase A/C");
        if (!purchaseInfoData.typeName) missing.push("Type");
        if (!purchaseInfoData.cashAccId) missing.push("Cash A/C");
        if (!purchaseInfoData.grandTotal)
          missing.push("Grand Total (check items)");
        alert(
          "Please complete all required fields. Missing: " + missing.join(", "),
        );
        setEditDisabled(false);
        setSaveDisabled(false);
        setLoading(false);
        return;
      }

      // Check if manually entered amount matches grand total
      if (purchaseInfoData.amount !== "" && purchaseInfoData.amount != null) {
        if (
          parseFloat(purchaseInfoData.amount) !==
          parseFloat(purchaseInfoData.grandTotal)
        ) {
          alert("Amount and Grand Total must be equal!");
          setEditDisabled(false);
          setSaveDisabled(false);
          setLoading(false);
          return;
        }
      }

      // filteredTableData already calculated above

      // Convert taxType from 1/0 to "Tax"/"NonTax"
      const taxTypeValue = purchaseInfoData.taxType === 1 ? "Tax" : "NonTax";

      // Format purchase info with proper numeric values
      const formattedPurchaseInfo = {
        EntryNo: parseInt(currentEntryNo),
        poNo: purchaseInfoData.poNo || null,
        taxType: taxTypeValue,
        cashorSupplierId: Array.isArray(purchaseInfoData.cashorSupplier)
          ? purchaseInfoData.cashorSupplier[0]
          : purchaseInfoData.cashorSupplier,
        supplierName: Array.isArray(purchaseInfoData.supplierName)
          ? purchaseInfoData.supplierName[1]
          : purchaseInfoData.supplierName,
        supplierInvoNo: purchaseInfoData.supplierInvoNo || null,
        amount:
          parseFloat(purchaseInfoData.amount || purchaseInfoData.grandTotal) ||
          0,
        date: purchaseInfoData.date,
        invoDate: purchaseInfoData.invoDate,
        purchaseAccId: purchaseInfoData.purchaseAccId,
        typeName: purchaseInfoData.typeName,
        ob: parseFloat(purchaseInfoData.ob) || 0,
        salesmanId: purchaseInfoData.salesmanId,
        locationId: purchaseInfoData.locationId,
        totalQty: parseInt(purchaseInfoData.totalQty) || 0,
        totalGrWt: parseFloat(purchaseInfoData.totalGrWt) || 0,
        totalStonewt: parseFloat(purchaseInfoData.totalStonewt) || 0,
        totalMudless: parseFloat(purchaseInfoData.totalMudless) || 0,
        totalNetwt: parseFloat(purchaseInfoData.totalNetwt) || 0,
        totalMc: parseFloat(purchaseInfoData.totalMc) || 0,
        totalWstg: parseFloat(purchaseInfoData.totalWstg) || 0,
        totalStAmt: parseFloat(purchaseInfoData.totalStAmt) || 0,
        totalGrossValue: parseFloat(purchaseInfoData.totalGrossValue) || 0,
        totalCgst: parseFloat(purchaseInfoData.totalCgst) || 0,
        totalSgst: parseFloat(purchaseInfoData.totalSgst) || 0,
        totalIgst: parseFloat(purchaseInfoData.totalIgst) || 0,
        itemsTotalAmount: parseFloat(purchaseInfoData.itemsTotalAmount) || 0,
        cashPaid: parseFloat(purchaseInfoData.cashPaid) || 0,
        cashAccId: purchaseInfoData.cashAccId,
        totalPureWt: parseFloat(purchaseInfoData.totalPureWt) || 0,
        totalLess: parseFloat(purchaseInfoData.totalLess) || 0,
        tdsPerc: parseFloat(purchaseInfoData.tdsPerc) || 0,
        tdsAmount: parseFloat(purchaseInfoData.tdsAmount) || 0,
        cess: parseFloat(purchaseInfoData.cess) || 0,
        otherCharge: parseFloat(purchaseInfoData.otherCharge) || 0,
        discount: parseFloat(purchaseInfoData.discount) || 0,
        roundOff: parseFloat(purchaseInfoData.roundOff) || 0,
        grandTotal: parseFloat(purchaseInfoData.grandTotal) || 0,
        exchangeNo: purchaseInfoData.exchangeNo || null,
        exchangeAmount: parseFloat(purchaseInfoData.exchangeAmount) || 0,
        returnNo: purchaseInfoData.returnNo || null,
        returnAmount: parseFloat(purchaseInfoData.returnAmount) || 0,
        totalNetAmount: parseFloat(purchaseInfoData.totalNetAmount) || 0,
        currentBalance: parseFloat(purchaseInfoData.currentBalance) || 0,
        ow: parseFloat(purchaseInfoData.ow) || 0,
        currentWeight: parseFloat(purchaseInfoData.currentWeight) || 0,
      };

      // Format table data with proper numeric values
      const formattedTableData = filteredTableData.map((row) => ({
        ItemCode: row.ItemCodeId,
        ProductName: row.ProductNameId,
        ModelName: row.ModelNameId,
        RateGm: parseFloat(row.RateGm) || 0,
        Qty: parseInt(row.Qty) || 0,
        GrWt: parseFloat(row.GrWt) || 0,
        StoneWt: parseFloat(row.StoneWt) || 0,
        MudLess: parseFloat(row.MudLess) || 0,
        WstgGm: parseFloat(row.WstgGm) || 0,
        NetWeight: parseFloat(row.NetWeight) || 0,
        Touchperc: parseFloat(row.Touchperc) || 0,
        Divperc: parseFloat(row.Divperc) || 0,
        thangam: parseFloat(row.thangam) || 0,
        StoneAmt: parseFloat(row.StoneAmt) || 0,
        Mc: parseFloat(row.Mc) || 0,
        GrossValue: parseFloat(row.GrossValue) || 0,
        NetAmount: parseFloat(row.NetAmount) || 0,
        CGST: parseFloat(row.CGST) || 0,
        SGST: parseFloat(row.SGST) || 0,
        IGST: parseFloat(row.IGST) || 0,
        cgstPerc: parseFloat(row.cgstPerc) || 0,
        sgstPerc: parseFloat(row.sgstPerc) || 0,
        igstPerc: parseFloat(row.igstPerc) || 0,
        TotalAmount: parseFloat(row.TotalAmount) || 0,
        lessWt: parseFloat(row.lessWt) || 0,
        lessPerc: parseFloat(row.lessPerc) || 0,
      }));

      //console.log("Sending update request with data:", {
      //   P_info: formattedPurchaseInfo,
      //   P_parti: formattedTableData,
      //   agCode: agentCode
      // });

      const response = await axios.post(
        `${apiBaseUrl}/purchase/updatePurchase/${parseInt(frmId)}/${fyid}/${dbCode}`,
        {
          P_info: formattedPurchaseInfo,
          P_parti: formattedTableData,
          agCode: agentCode,
        },
      );

      if (response.data.success) {
        setLoading(false);
        setEditDisabled(false);
        setSaveDisabled(true);

        alert(`Entry Updated Successfully! Entry No: ${response.data.entryNo}`);

        // Refresh first and last after update
        fetchfirstandlast();

        // Optional: Show success message and keep edit mode enabled
        //console.log("Update successful");
      } else {
        setLoading(false);
        setEditDisabled(false);
        setSaveDisabled(false);
        alert(
          "Failed to update data: " +
            (response.data.message || "Unknown error"),
        );
      }
    } catch (error) {
      console.error("Error updating data:", error);
      setLoading(false);
      setEditDisabled(false);
      setSaveDisabled(false);

      if (error.response) {
        alert(`Error: ${error.response.data.message || "Server error"}`);
      } else if (error.request) {
        alert("Network error. Please check your connection.");
      } else {
        alert("Error: " + error.message);
      }
    }
  };
  // Helper to format ISO date strings to YYYY-MM-DD (same as SchemeReceipt)
  const formatDate = (dateString) => {
    if (!dateString) return getCurrentDate();
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Helper function to load entry data
  const loadEntryData = async (data) => {
    // Prevent grandTotal useEffect from firing during load (race condition fix)
    isLoadingEntryRef.current = true;
    const purchaseInfo = data[0][0];
    const particulars = data[1] || [];
    const taxTypeValue = purchaseInfo.TaxType === "Tax" ? 1 : 0;

    //console.log("Found Purchase Info:", purchaseInfo);
    //console.log("Found Particulars:", particulars);

    // Set current entry number
    setCurrentEntryNo(purchaseInfo.EntryNo);

    // Map particulars rows
    const newTableData = particulars.map((row) => {
      const product = pDetails.find((item) => item.slNo === row.ProductName);

      return {
        ItemCodeId: row.ItemCode || "",
        ItemCodeLabel:
          pCode.find((item) => item.value === row.ItemCode)?.label || "",
        ProductNameId: row.ProductName || "",
        ProductNameLabel:
          pNames.find((item) => item.value === row.ProductName)?.label || "",
        ModelNameId: row.ModelName || "",
        ModelNameLabel:
          modelOpts.find((item) => item.value === row.ModelName)?.label || "",
        RateGm: row.RateGm || "",
        Qty: row.Qty || "",
        GrWt: row.GrWt || "",
        StoneWt: row.StoneWt || "",
        MudLess: row.MudLess || "",
        WstgGm: row.WstgGm || "",
        NetWeight: row.NetWeight || "",
        Touchperc: row.Touchperc || "",
        Divperc: row.Divperc || "",
        thangam: row.PureWt || "",
        StoneAmt: row.StoneAmt || "",
        Mc: row.Mc || "",
        GrossValue: row.GrossValue || "",
        CGST: row.CGST || "",
        SGST: row.SGST || "",
        IGST: row.IGST || "",
        TotalAmount: row.Amount || "",
        lessWt: row.LessWt || "",
        lessPerc: row.LessPerc || "",
        NetAmount: row.NetAmount || "",
        cgstPerc: product ? product.cgst : 0,
        sgstPerc: product ? product.sgst : 0,
        igstPerc: product ? product.igst : 0,
      };
    });

    // Perform Recalculations for loaded data
    const loadedTransType = purchaseInfo.PurchaseType || "PURCHASE";
    newTableData.forEach((row) => {
      if (row.ProductNameId || row.ItemCodeId) {
        PurchaseTableCalculations(row, taxTypeValue, loadedTransType);
      }
    });

    // Pad with empty rows to keep at least 15 rows in table
    while (newTableData.length < 15) {
      newTableData.push({
        ItemCodeId: "",
        ItemCodeLabel: "",
        ProductNameId: "",
        ProductNameLabel: "",
        ModelNameId: "",
        ModelNameLabel: "",
        RateGm: "",
        Qty: "",
        GrWt: "",
        StoneWt: "",
        MudLess: "",
        WstgGm: "",
        NetWeight: "",
        Touchperc: "",
        Divperc: "",
        thangam: "",
        StoneAmt: "",
        Mc: "",
        GrossValue: "",
        CGST: "",
        SGST: "",
        IGST: "",
        TotalAmount: "",
        lessWt: "",
        lessPerc: "",
        NetAmount: "",
        cgstPerc: 0,
        sgstPerc: 0,
        igstPerc: 0,
      });
    }

    setTableData(newTableData);

    // Convert taxType from string to number for radio button

    // Map header fields
    setpurchaseInfoData({
      ...purchaseInfoData,
      EntryNo: purchaseInfo.EntryNo,
      poNo: purchaseInfo.PoNo || "",
      taxType: taxTypeValue,
      cashorSupplier: purchasecashorsuppl.find(
        (item) => item[0] === purchaseInfo.CashOrSupplier,
      ) || [purchaseInfo.CashOrSupplier, purchaseInfo.SupplierName],
      supplierName: purchaseInfo.SupplierName || "",
      supplierInvoNo: purchaseInfo.SupplierInvoNo || "",
      amount: purchaseInfo.Amount || "",
      date: formatDate(purchaseInfo.Date),
      invoDate: formatDate(purchaseInfo.InVoDate),
      purchaseAccId: purchaseInfo.PurchaseAcc,
      purchaseAccName:
        pAcc.find((item) => item.value === purchaseInfo.PurchaseAcc)?.label ||
        "",
      typeId:
        typeOpts.find((item) => item.label === purchaseInfo.PurchaseType)
          ?.value || 1,
      typeName: purchaseInfo.PurchaseType || "PURCHASE",
      ob: purchaseInfo.OB || "",
      salesmanId: purchaseInfo.SalesMan,
      salesmanName:
        salesmanOpts.find((item) => item.value === purchaseInfo.SalesMan)
          ?.label || "",
      locationId: purchaseInfo.Location,
      locationName:
        locationOpts.find((item) => item.value === purchaseInfo.Location)
          ?.label || "",
      totalQty: purchaseInfo.TotalQty || "",
      totalGrWt: purchaseInfo.TotalGrWt || "",
      totalStonewt: purchaseInfo.TotalStonewt || "",
      totalMudless: purchaseInfo.TotalMudless || "",
      totalNetwt: purchaseInfo.TotalNetwt || "",
      totalMc: purchaseInfo.TotalMc || "",
      totalWstg: purchaseInfo.TotalWstg || "",
      totalStAmt: purchaseInfo.TotalStAmt || "",
      totalGrossValue: purchaseInfo.TotalGrossValue || "",
      totalCgst: purchaseInfo.TotalCgst || "",
      totalSgst: purchaseInfo.TotalSgst || "",
      totalIgst: purchaseInfo.TotalIgst || "",
      itemsTotalAmount: purchaseInfo.TotalAmount || "",
      cashPaid: purchaseInfo.CashPaid || "",
      cashAccId: purchaseInfo.CashAcc,
      cashAccName:
        caba.find((item) => item.value === purchaseInfo.CashAcc)?.label || "",
      totalPureWt: purchaseInfo.TotalPureWt || "",
      totalLess: purchaseInfo.TotalLess || "",
      tdsPerc: purchaseInfo.TdsPerc || "",
      tdsAmount: purchaseInfo.TdsAmount || "",
      cess: purchaseInfo.Cess || "",
      otherCharge: purchaseInfo.OtherCharge || "",
      discount: purchaseInfo.Discount || "",
      roundOff: purchaseInfo.RoundOff !== undefined ? purchaseInfo.RoundOff : (purchaseInfo.roundOff || ""),
      grandTotal: purchaseInfo.GrandTotal || "",
      exchangeNo: purchaseInfo.ExchangeNo || "",
      exchangeAmount: purchaseInfo.ExchangeAmount || "",
      returnNo: purchaseInfo.ReturnNo || "",
      returnAmount: purchaseInfo.ReturnAmount || "",
      totalNetAmount: purchaseInfo.TotalNetAmount || "",
      ow: purchaseInfo.OW || "",
      currentWeight: purchaseInfo.CurrentWeight || "",
      currentBalance: purchaseInfo.CurrentBalance,
    });

    // Set value for radio button
    setValue(taxTypeValue);

    setEditDisabled(false);
    setDeleteDisabled(false);
    setSaveDisabled(true);
    setDataFound(true);

    // Re-enable grandTotal recalculation after state has settled.
    // 300ms covers:
    //   - Synchronous React state batches (setTableData + setpurchaseInfoData)
    //   - Async effects: date-change useEffect → recalculateTableRatesForDate
    //     fetches API rates and calls setTableData asynchronously.
    //   Without the delay, the async fetch could resolve AFTER setTimeout(0)
    //   and still trigger a grandTotal wipe.
    setTimeout(() => {
      isLoadingEntryRef.current = false;
    }, 300);
  };

  const handleFind = async () => {
    try {
      if (!findEntryNo || findEntryNo.trim() === "") {
        alert("Please enter an Entry No");
        return;
      }

      setLoading(true);

      const response = await axios.get(
        `${apiBaseUrl}/purchase/findpventry/${findEntryNo}/${frmId}/${fyid}/${dbCode}`,
      );

      const data = response.data;

      if (data && data[0] && data[0].length > 0) {
        await loadEntryData(data);
        closeFindDialog();
      } else {
        alert(`Entry No ${findEntryNo} not found!`);
      }
    } catch (error) {
      console.error("Error finding entry:", error.message);
      alert("Error finding entry: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!currentEntryNo) {
      alert("No entry selected to delete");
      return;
    }

    if (
      !window.confirm(
        `Are you sure you want to permanently DELETE Entry No: ${currentEntryNo}? This action cannot be undone.`,
      )
    ) {
      return;
    }

    setLoading(true);
    try {
      const response = await axios.delete(
        `${apiBaseUrl}/purchase/deletepventry/${currentEntryNo}/${frmId}/${fyid}/${dbCode}?location=${purchaseInfoData.locationId || 0}`,
      );

      if (response.data.success) {
        alert(`Entry No ${currentEntryNo} deleted successfully!`);
        handleClear();
        fetchfirstandlast();
        fetchPEntryno();
        setCurrentEntryNo(null);
        setEditDisabled(true);
        setDeleteDisabled(true);
        setSaveDisabled(false);
        setDataFound(false);
      } else {
        alert(
          "Failed to delete entry: " +
            (response.data.message || "Unknown error"),
        );
      }
    } catch (error) {
      console.error("Error deleting entry:", error.message);
      alert(
        "Error deleting entry: " +
          (error.response?.data?.message || error.message),
      );
    } finally {
      setLoading(false);
    }
  };

  // Navigation functions
  const handleFirst = async () => {
    //console.log("firstEntryNo", firstEntryNo);

    if (!firstEntryNo) {
      alert("First entry not available");
      return;
    }

    setFindEntryNo(firstEntryNo.toString());

    await navigateToEntry(firstEntryNo.toString());
  };

  const handleLast = async () => {
    //console.log("lastEntryNo", lastEntryNo);

    if (!lastEntryNo) {
      alert("Last entry not available");
      return;
    }

    setFindEntryNo(lastEntryNo.toString());
    await navigateToEntry(lastEntryNo.toString());
  };

  const handlePrevious = async () => {
    await fetchfirstandlast();
    if (!currentEntryNo) {
      alert("No current entry selected");
      return;
    }

    setIsNavigating(true);
    let prevEntryNo = parseInt(currentEntryNo) - 1;
    let found = false;
    let attempts = 0;
    const maxAttempts = 10;

    while (
      !found &&
      prevEntryNo >= (firstEntryNo || 1) &&
      attempts < maxAttempts
    ) {
      try {
        setLoading(true);
        const response = await axios.get(
          `${apiBaseUrl}/purchase/findpventry/${prevEntryNo}/${frmId}/${fyid}/${dbCode}`,
        );

        const data = response.data;

        if (data && data[0] && data[0].length > 0) {
          // Entry found
          setFindEntryNo(prevEntryNo.toString());
          await loadEntryData(data);
          found = true;
        } else {
          // Entry not found, try next previous
          prevEntryNo--;
          attempts++;
        }
      } catch (error) {
        console.error(`Error checking entry ${prevEntryNo}:`, error.message);
        prevEntryNo--;
        attempts++;
      } finally {
        setLoading(false);
      }
    }

    if (!found) {
      alert("No previous entries found");
    }
    setIsNavigating(false);
  };

  const handleNext = async () => {
    await fetchfirstandlast();
    if (!currentEntryNo) {
      alert("No current entry selected");
      return;
    }

    setIsNavigating(true);
    let nextEntryNo = parseInt(currentEntryNo) + 1;
    let found = false;
    let attempts = 0;
    const maxAttempts = 10; // Prevent infinite loop

    while (
      !found &&
      nextEntryNo <= (lastEntryNo || 999999) &&
      attempts < maxAttempts
    ) {
      try {
        setLoading(true);
        const response = await axios.get(
          `${apiBaseUrl}/purchase/findpventry/${nextEntryNo}/${frmId}/${fyid}/${dbCode}`,
        );

        const data = response.data;

        if (data && data[0] && data[0].length > 0) {
          // Entry found
          setFindEntryNo(nextEntryNo.toString());
          await loadEntryData(data);
          found = true;
        } else {
          // Entry not found, try next next
          nextEntryNo++;
          attempts++;
        }
      } catch (error) {
        console.error(`Error checking entry ${nextEntryNo}:`, error.message);
        nextEntryNo++;
        attempts++;
      } finally {
        setLoading(false);
      }
    }

    if (!found) {
      alert("No next entries found");
    }
    setIsNavigating(false);
  };

  const navigateToEntry = async (entryNo) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${apiBaseUrl}/purchase/findpventry/${entryNo}/${frmId}/${fyid}/${dbCode}`,
      );

      const data = response.data;

      if (data && data[0] && data[0].length > 0) {
        await loadEntryData(data);
      } else {
        alert(`Entry No ${entryNo} not found!`);
      }
    } catch (error) {
      console.error("Error finding entry:", error.message);
      alert("Error finding entry: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveRow = (rowIndex) => {
    const hasData = Object.values(tableData[rowIndex]).some(
      (value) => value !== "" && value !== 0,
    );

    if (hasData) {
      if (!window.confirm("Are you sure you want to remove this item?")) {
        return;
      }
    }

    if (tableData.length > 1) {
      const newData = [...tableData];
      newData.splice(rowIndex, 1);

      if (newData.length < 15) {
        newData.push({
          ItemCode: "",
          ProductName: "",
          ModelName: "",
          RateGm: "",
          Qty: "",
          GrWt: "",
          StoneWt: "",
          MudLess: "",
          WstgGm: "",
          NetWeight: "",
          Touchperc: "",
          Divperc: "",
          thangam: "",
          StoneAmt: "",
          Mc: "",
          GrossValue: "",
          NetAmount: "",
          CGST: "",
          SGST: "",
          IGST: "",
          TotalAmount: "",
          lessWt: "",
          lessPerc: "",
        });
      }

      setTableData(newData);

      // If the removed row was the currently focused row, adjust RowIndex
      if (rowIndex <= RowIndex && RowIndex > 0) {
        setRowIndex(RowIndex - 1);
      }
    }
  };

  // Handle dynamic default values and Tax inclusive setting from configuration
  useEffect(() => {
    if (formFields && formFields.length > 0) {
      setpurchaseInfoData((prevData) => {
        let updatedData = { ...prevData };
        let dataChanged = false;

        formFields.forEach((fld) => {
          // Handle checkbox/radio field checked states
          if (fld.fieldId === "Tax") {
            const expectedVal = fld.checked ? 1 : 0;
            if (updatedData.taxType !== expectedVal) {
              setValue(expectedVal);
              updatedData.taxType = expectedVal;
              dataChanged = true;
            }
          }
          if (fld.fieldId === "PrintOB") {
            if (updatedData.printOB !== fld.checked) {
              updatedData.printOB = fld.checked;
              dataChanged = true;
            }
          }

          const defVal = fld.defaultValue ? fld.defaultValue.trim() : "";
          if (defVal !== "") {
            switch (fld.fieldId) {
              case "EntryNo":
                if (updatedData.EntryNo === "" || updatedData.EntryNo === undefined) {
                  updatedData.EntryNo = defVal;
                  dataChanged = true;
                }
                break;
              case "PoNo":
                if (updatedData.poNo === "" || updatedData.poNo === undefined) {
                  updatedData.poNo = defVal;
                  dataChanged = true;
                }
                break;
              case "SupplierInvNo":
                if (
                  updatedData.supplierInvoNo === "" ||
                  updatedData.supplierInvoNo === undefined
                ) {
                  updatedData.supplierInvoNo = defVal;
                  dataChanged = true;
                }
                break;
              case "Amount":
                if (
                  updatedData.amount === "" ||
                  updatedData.amount === undefined
                ) {
                  updatedData.amount = defVal;
                  dataChanged = true;
                }
                break;
              case "OB":
                if (updatedData.ob === "" || updatedData.ob === undefined) {
                  updatedData.ob = defVal;
                  dataChanged = true;
                }
                break;
              case "OW":
                if (updatedData.ow === "" || updatedData.ow === undefined) {
                  updatedData.ow = defVal;
                  dataChanged = true;
                }
                break;
              case "Date":
                if (!updatedData.date || updatedData.date === getCurrentDate()) {
                  updatedData.date = defVal;
                  dataChanged = true;
                }
                break;
              case "InvoiceDate":
                if (
                  !updatedData.invoDate ||
                  updatedData.invoDate === getCurrentDate()
                ) {
                  updatedData.invoDate = defVal;
                  dataChanged = true;
                }
                break;
              case "CashorSupplier":
                if (
                  !updatedData.cashorSupplier ||
                  (Array.isArray(updatedData.cashorSupplier) &&
                    updatedData.cashorSupplier[1] === "CASH")
                ) {
                  const found = purchasecashorsuppl.find(
                    (opt) =>
                      String(opt[0]) === defVal ||
                      String(opt[1]).toLowerCase() === defVal.toLowerCase(),
                  );
                  updatedData.cashorSupplier = found || ["", defVal];
                  dataChanged = true;
                }
                break;
              case "SupplierName":
                if (!updatedData.supplierName) {
                  const found = purchasecashorsuppl.find(
                    (opt) =>
                      String(opt[0]) === defVal ||
                      String(opt[1]).toLowerCase() === defVal.toLowerCase(),
                  );
                  updatedData.supplierName = found || ["", defVal];
                  dataChanged = true;
                }
                break;
              case "PurchaseAC":
                if (!updatedData.purchaseAccId || updatedData.purchaseAccId === 12) {
                  const found = pAcc.find(
                    (opt) =>
                      String(opt.value) === defVal ||
                      String(opt.label).toLowerCase() === defVal.toLowerCase(),
                  );
                  if (found) {
                    updatedData.purchaseAccId = found.value;
                    updatedData.purchaseAccName = found.label;
                  } else {
                    updatedData.purchaseAccId = "";
                    updatedData.purchaseAccName = defVal;
                  }
                  dataChanged = true;
                }
                break;
              case "Type":
                if (!updatedData.typeId || updatedData.typeId === 1) {
                  const found = typeOpts.find(
                    (opt) =>
                      String(opt.value) === defVal ||
                      String(opt.label).toLowerCase() === defVal.toLowerCase(),
                  );
                  if (found) {
                    updatedData.typeId = found.value;
                    updatedData.typeName = found.label;
                  } else {
                    updatedData.typeId = "";
                    updatedData.typeName = defVal;
                  }
                  dataChanged = true;
                }
                break;
              case "Salesman":
                if (!updatedData.salesmanId) {
                  const found = salesmanOpts.find(
                    (opt) =>
                      String(opt.value) === defVal ||
                      String(opt.label).toLowerCase() === defVal.toLowerCase(),
                  );
                  if (found) {
                    updatedData.salesmanId = found.value;
                    updatedData.salesmanName = found.label;
                  } else {
                    updatedData.salesmanId = "";
                    updatedData.salesmanName = defVal;
                  }
                  dataChanged = true;
                }
                break;
              case "Location":
                if (!updatedData.locationId) {
                  const found = locationOpts.find(
                    (opt) =>
                      String(opt.value) === defVal ||
                      String(opt.label).toLowerCase() === defVal.toLowerCase(),
                  );
                  if (found) {
                    updatedData.locationId = found.value;
                    updatedData.locationName = found.label;
                  } else {
                    updatedData.locationId = "";
                    updatedData.locationName = defVal;
                  }
                  dataChanged = true;
                }
                break;
              case "CashAC":
                if (!updatedData.cashAccId || updatedData.cashAccId === 4) {
                  const found = caba.find(
                    (opt) =>
                      String(opt.value) === defVal ||
                      String(opt.label).toLowerCase() === defVal.toLowerCase(),
                  );
                  if (found) {
                    updatedData.cashAccId = found.value;
                    updatedData.cashAccName = found.label;
                  } else {
                    updatedData.cashAccId = "";
                    updatedData.cashAccName = defVal;
                  }
                  dataChanged = true;
                }
                break;
              case "CashPaid":
                if (!updatedData.cashPaid) {
                  updatedData.cashPaid = defVal;
                  dataChanged = true;
                }
                break;
              case "OtherCharges":
                if (!updatedData.otherCharge) {
                  updatedData.otherCharge = defVal;
                  dataChanged = true;
                }
                break;
              case "Discount":
                if (!updatedData.discount) {
                  updatedData.discount = defVal;
                  dataChanged = true;
                }
                break;
              case "RoundOffAmt":
                if (!updatedData.roundOff) {
                  updatedData.roundOff = defVal;
                  dataChanged = true;
                }
                break;
              case "CurrentWeight":
                if (!updatedData.currentWeight) {
                  updatedData.currentWeight = defVal;
                  dataChanged = true;
                }
                break;
              case "CurrentBalance":
                if (!updatedData.currentBalance) {
                  updatedData.currentBalance = defVal;
                  dataChanged = true;
                }
                break;
              case "GrandTotal":
                if (!updatedData.grandTotal) {
                  updatedData.grandTotal = defVal;
                  dataChanged = true;
                }
                break;
              case "ExchangeNo":
                if (!updatedData.exchangeNo) {
                  updatedData.exchangeNo = defVal;
                  dataChanged = true;
                }
                break;
              case "ExchangeAmt":
                if (!updatedData.exchangeAmount) {
                  updatedData.exchangeAmount = defVal;
                  dataChanged = true;
                }
                break;
              case "ReturnNo":
                if (!updatedData.returnNo) {
                  updatedData.returnNo = defVal;
                  dataChanged = true;
                }
                break;
              case "ReturnAmt":
                if (!updatedData.returnAmount) {
                  updatedData.returnAmount = defVal;
                  dataChanged = true;
                }
                break;
              case "TdsPerc":
                if (!updatedData.tdsPerc) {
                  updatedData.tdsPerc = defVal;
                  dataChanged = true;
                }
                break;
              case "TdsAmt":
                if (!updatedData.tdsAmount) {
                  updatedData.tdsAmount = defVal;
                  dataChanged = true;
                }
                break;
              case "Cess":
                if (!updatedData.cess) {
                  updatedData.cess = defVal;
                  dataChanged = true;
                }
                break;
              case "TotalPureWt":
                if (!updatedData.totalPureWt) {
                  updatedData.totalPureWt = defVal;
                  dataChanged = true;
                }
                break;
              case "TotalLess":
                if (!updatedData.totalLess) {
                  updatedData.totalLess = defVal;
                  dataChanged = true;
                }
                break;
              default:
                break;
            }
          }
        });

        return dataChanged ? updatedData : prevData;
      });
    }
  }, [
    formFields,
    purchasecashorsuppl,
    pAcc,
    typeOpts,
    salesmanOpts,
    locationOpts,
    caba,
  ]);

  return (
    <div
      className="absolute inset-0 w-full h-full bg-[#f0f0f0] flex items-center justify-center pointer-events-auto"
      style={{ zIndex: zIndex || 100 }}
    >

      <div
        className="bg-white font-normal 
                 w-[90%] h-[85%] max-h-[900px] max-w-[1440px]
                 md:w-[90%] md:h-[85%] 
                 lg:w-[98%] lg:h-[82vh] 
                 rounded-[5px] shadow-md 
                 flex flex-col items-center 
                 absolute transition-all duration-300 font-Inter overflow-hidden"
      >
        <WindowHeader
          title={fname || "Purchase Entry"}
          logo={headeLogo}
          onClose={onClose}
          className="bg-[#0f56d3] text-white"
          closeBtnClassName="w-6 h-6 rounded-[5px] border-none mr-2"
        />

        {/*............................ ActionToolbar.............................................. */}
        <ActionToolbar
          width="100%"
          height="auto"
          size="small"
          iconSize={14}
          navBgColor="#0f56d3"
          navIconColor="#ffffff"
          buttonGap="5px"
          arrowGap="2%"
          saveBtnId="SaveBtn"
          printBtnId="PrintBtn"
          clearBtnId="ClearBtn"
          findBtnId="FindBtn"
          editBtnId="EditBtn"
          deleteBtnId="DeleteBtn"
          exitBtnId="ExitBtn"
          showSave={isFieldVisible("SaveBtn")}
          showPrint={isFieldVisible("PrintBtn")}
          showClear={isFieldVisible("ClearBtn")}
          showFind={isFieldVisible("FindBtn")}
          showEdit={isFieldVisible("EditBtn")}
          showDelete={isFieldVisible("DeleteBtn")}
          showExit={isFieldVisible("ExitBtn")}
          showNavigation={true}
          saveDisabled={isFieldDisabled("SaveBtn") || saveDisabled}
          editDisabled={isFieldDisabled("EditBtn") || editDisabled}
          deleteDisabled={isFieldDisabled("DeleteBtn") || deleteDisabled}
          findDisabled={isFieldDisabled("FindBtn")}
          dataFound={dataFound}
          permissions={permissions}
          permissionKey="purchase"
          onSave={handleSave}
          onPrint={() => {}}
          onClear={handleClear}
          onFind={openFindDialog}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onExit={onClose}
          onFirst={handleFirst}
          onPrevious={handlePrevious}
          onNext={handleNext}
          onLast={handleLast}
          showSettingsBar={true}
          onRefresh={handleRefresh}
          isRefreshing={isRefreshing}
          settingsOptions={[
            {
              label: "Design Columns",
              onClick: () => setShowGridDesignModal(true),
            },
            {
              label: "Design Form",
              onClick: () => setShowFormDesignModal(true),
            },
          ]}
          onRefsUpdate={(refs) => {
            if (refs.saveButtonRef && refs.saveButtonRef.current) {
              saveButtonInputRef.current = refs.saveButtonRef.current;
              registerRef("SaveBtn")(refs.saveButtonRef.current);
            }
            if (refs.editButtonRef && refs.editButtonRef.current) {
              registerRef("EditBtn")(refs.editButtonRef.current);
            }
          }}
        />
        {/*............................ ActionToolbarEnd.............................................. */}
        {/* Simple Centered Loading Spinner Overlay */}
        {loading && (
          <div className="absolute inset-0 bg-black/40 flex items-center justify-center z-50">
            <div className="w-10 h-10 border-4 border-white border-t-[#0f56d3] rounded-full animate-spin"></div>
          </div>
        )}

        {/* ................................TopData Part................................... */}

        <div className="font-Inter w-[97.6%] h-[68px] flex shrink-0 gap-[1%] mt-[0.5%] text-black text-[10px] font-semibold leading-normal">
          <div className="font-Inter flex flex-col w-[12.9%] gap-1 pl-2">
            <div
              className="font-Inter w-full h-[20px] flex items-center justify-between"
              style={getContainerStyle("EntryNo")}
            >
              <label className="font-Inter text-nowrap w-[38%] text-left" style={getLabelStyle("EntryNo")}>
                Entry No
              </label>
              <input
                value={purchaseInfoData.EntryNo}
                ref={(el) => {
                  registerRef("EntryNo")(el);
                  entryNoInputRef.current = el;
                }}
                className="font-Inter w-[60%] h-full text-center px-2 box-border border border-[#4a4a4a] text-[10px]"
                readOnly={isFieldReadOnly("EntryNo", true) || isFieldDisabled("EntryNo")}
                style={getInputStyle("EntryNo")}
              />
            </div>
            <div
              className="font-Inter w-full h-[20px] flex items-center justify-between"
              style={getContainerStyle("PoNo")}
            >
              <label className="font-Inter text-nowrap w-[38%] text-left" style={getLabelStyle("PoNo")}>
                {" "}
                Po No
              </label>
              <input
                ref={(el) => {
                  registerRef("PoNo")(el);
                  PoNoInputRef.current = el;
                }}
                value={purchaseInfoData.poNo}
                onChange={(e) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    poNo: e.target.value,
                  })
                }
                onKeyDown={(e) => handleKeyDown(e, "PoNo")}
                className="font-Inter w-[60%] h-full px-2 box-border border border-[#4a4a4a] text-[10px]"
                readOnly={isFieldReadOnly("PoNo") || isFieldDisabled("PoNo")}
                style={getInputStyle("PoNo")}
              />
            </div>
            <div
              className="font-Inter w-full h-[20px] flex items-center justify-start"
              style={getContainerStyle("Tax")}
            >
              <label className="font-Inter text-nowrap w-[25%] text-left" style={getLabelStyle("Tax")}></label>
              <div className="font-Inter flex h-full w-[73%]">
                <Radio.Group
                  className="font-Inter flex justify-start gap-2 w-full"
                  onChange={onRadioChange}
                  value={value}
                  disabled={isFieldDisabled("Tax")}
                >
                  <Radio
                    ref={(el) => {
                      registerRef("Tax")(el);
                      TaxInputRef.current = el;
                    }}
                    onKeyDown={(e) => handleKeyDown(e, "Tax")}
                    value={1}
                    className="text-black text-[10px] font-semibold leading-normal"
                    style={getInputStyle("Tax")}
                  >
                    Tax
                  </Radio>
                  <Radio
                    ref={NontaxInputRef}
                    onKeyDown={(e) => handleKeyDown(e, "Tax")}
                    value={0}
                    className="text-black text-[10px] font-semibold leading-normal"
                    style={getInputStyle("Tax")}
                  >
                    NonTax
                  </Radio>
                </Radio.Group>
              </div>
            </div>
          </div>
          <div className="font-Inter flex flex-col w-[30%] gap-1 pl-2">
            <div
              className="font-Inter w-full h-[20px] flex items-center justify-between"
              style={getContainerStyle("CashorSupplier")}
            >
              <label className="font-Inter text-nowrap w-[38%] text-left" style={getLabelStyle("CashorSupplier")}>
                Cash / Supplier
              </label>
              <ComboBox1
                findedValue={
                  Array.isArray(purchaseInfoData.cashorSupplier)
                    ? purchaseInfoData.cashorSupplier[1]
                    : purchaseInfoData.cashorSupplier
                }
                onInputChange={(value) => {
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    cashorSupplier: value,
                  });

                  if (value && value[0]) {
                    fetchSupplierOB(value[0]);
                  }
                }}
                inputClassName="w-full h-full box-border border border-[#4a4a4a] text-[10px]"
                inputPadding="0 8px"
                inlineStyles={getInputStyle("CashorSupplier", { height: "20px", fontSize: "10px" })}
                className="font-Inter w-[60%] h-full"
                comboRef={(el) => {
                  registerRef("CashorSupplier")(el);
                  cashSupplierInputRef.current = el;
                }}
                options={purchasecashorsuppl}
                onKeyDown={(e) => {
                  handleKeyDown(e, "CashorSupplier");
                }}
                onBlur={(e) => {
                  handleCheckSupplier(e);
                }}
                disabled={isFieldDisabled("CashorSupplier")}
              />
            </div>
            <div
              className="font-Inter w-full h-[20px] flex items-center justify-between"
              style={getContainerStyle("SupplierName")}
            >
              <label className="font-Inter text-nowrap w-[38%] text-left" style={getLabelStyle("SupplierName")}>
                Supplier Name
              </label>
              <ComboBox
                findedValue={
                  Array.isArray(purchaseInfoData.cashorSupplier)
                    ? Array.isArray(purchaseInfoData.cashorSupplier)
                      ? purchaseInfoData.cashorSupplier[1]
                      : purchaseInfoData.cashorSupplier
                    : Array.isArray(purchaseInfoData.supplierName)
                      ? purchaseInfoData.supplierName[1]
                      : purchaseInfoData.supplierName
                }
                onInputChange={(value) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    supplierName: value,
                  })
                }
                onKeyDown={(e) => handleKeyDown(e, "SupplierName")}
                comboRef={(el) => {
                  registerRef("SupplierName")(el);
                  supplierNameInputRef.current = el;
                }}
                options={purchasecashorsuppl}
                inputClassName="w-full h-full box-border border border-[#4a4a4a] text-[10px]"
                inputPadding="0 8px"
                inlineStyles={getInputStyle("SupplierName", { height: "20px", fontSize: "10px" })}
                className="font-Inter w-[60%] h-full"
                disabled={isFieldDisabled("SupplierName")}
              />
            </div>
            <div
              className="font-Inter flex justify-between w-full h-[20px] items-center"
              style={{
                display:
                  isFieldVisible("SupplierInvNo") || isFieldVisible("Amount")
                    ? "flex"
                    : "none",
              }}
            >
              <label
                className="font-Inter w-[38%] text-left text-nowrap"
                style={{
                  display: isFieldVisible("SupplierInvNo") ? "block" : "none",
                  ...getLabelStyle("SupplierInvNo"),
                }}
              >
                Supplier InvNo
              </label>
              <div className="font-Inter flex items-center w-[60%] h-full gap-1.5 ml-auto">
                <input
                  value={
                    Array.isArray(purchaseInfoData.supplierInvoNo)
                      ? purchaseInfoData.supplierInvoNo[1]
                      : purchaseInfoData.supplierInvoNo
                  }
                  onChange={(e) =>
                    setpurchaseInfoData({
                      ...purchaseInfoData,
                      supplierInvoNo: e.target.value,
                    })
                  }
                  onKeyDown={(e) => handleKeyDown(e, "SupplierInvNo")}
                  ref={(el) => {
                    registerRef("SupplierInvNo")(el);
                    supplierInVoNoInputRef.current = el;
                  }}
                  className="font-Inter h-full w-[24%] px-2 box-border shrink-0 border border-[#4a4a4a] text-[10px]"
                  readOnly={isFieldReadOnly("SupplierInvNo") || isFieldDisabled("SupplierInvNo")}
                  style={{
                    display: isFieldVisible("SupplierInvNo")
                      ? "inline-block"
                      : "none",
                    ...getInputStyle("SupplierInvNo"),
                  }}
                />
                <button
                  ref={searchBtnInputRef}
                  className="font-Inter bg-[#bcbcbc] w-[26%] h-full rounded-md shrink-0 border border-[#4a4a4a] text-[10px] flex items-center justify-center border-none"
                  type="button"
                  style={{
                    display: isFieldVisible("SupplierInvNo") ? "flex" : "none",
                    ...getInputStyle("SupplierInvNo"),
                  }}
                >
                  Search
                </button>
                <label
                  className="font-Inter text-nowrap ml-auto pr-1"
                  style={{
                    display: isFieldVisible("Amount") ? "block" : "none",
                    ...getLabelStyle("Amount"),
                  }}
                >
                  Amt
                </label>
                <input
                  value={
                    purchaseInfoData.amount === "" ||
                    purchaseInfoData.amount == null
                      ? purchaseInfoData.grandTotal
                      : purchaseInfoData.amount
                  }
                  onChange={(e) =>
                    setpurchaseInfoData({
                      ...purchaseInfoData,
                      amount: e.target.value,
                    })
                  }
                  ref={(el) => {
                    registerRef("Amount")(el);
                    amountInputRef.current = el;
                  }}
                  className="font-Inter text-right w-[28%] h-full px-2 box-border shrink-0 border border-[#4a4a4a] text-[10px]"
                  onKeyDown={(e) => handleKeyDown(e, "Amount")}
                  readOnly={isFieldReadOnly("Amount") || isFieldDisabled("Amount")}
                  style={{
                    display: isFieldVisible("Amount") ? "inline-block" : "none",
                    ...getInputStyle("Amount"),
                  }}
                />
              </div>
            </div>
          </div>
          <div className="font-Inter flex flex-col w-[15.9%] gap-1 pl-2">
            <div
              className="font-Inter w-full h-[20px] flex items-center justify-between"
              style={getContainerStyle("Date")}
            >
              <label className="font-Inter text-nowrap w-[38%] text-left" style={getLabelStyle("Date")}>
                Date
              </label>
              <input
                className="font-Inter w-[60%] h-full px-2 box-border border border-[#4a4a4a] text-[10px]"
                ref={(el) => {
                  registerRef("Date")(el);
                  dateInputRef.current = el;
                }}
                onKeyDown={(e) => handleKeyDown(e, "Date")}
                type="date"
                min={minDate}
                max={maxDate}
                value={purchaseInfoData.date}
                onChange={(e) => {
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    date: e.target.value,
                  });
                }}
                onBlur={(e) => {
                  const val = e.target.value;
                  if (val && !isDateInFy(val)) {
                    alert("Date incompatible with financial year");
                  }
                }}
                readOnly={isFieldReadOnly("Date") || isFieldDisabled("Date")}
                style={getInputStyle("Date")}
              />
            </div>
            <div
              className="font-Inter w-full h-[20px] flex items-center justify-between"
              style={getContainerStyle("InvoiceDate")}
            >
              <label className="font-Inter text-nowrap w-[38%] text-left" style={getLabelStyle("InvoiceDate")}>
                Invoice Date
              </label>
              <input
                className="font-Inter w-[60%] h-full px-2 box-border border border-[#4a4a4a] text-[10px]"
                ref={(el) => {
                  registerRef("InvoiceDate")(el);
                  invoDateInputRef.current = el;
                }}
                onKeyDown={(e) => handleKeyDown(e, "InvoiceDate")}
                type="date"
                min={minDate}
                max={maxDate}
                value={purchaseInfoData.invoDate}
                onChange={(e) => {
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    invoDate: e.target.value,
                  });
                }}
                onBlur={(e) => {
                  const val = e.target.value;
                  if (val && !isDateInFy(val)) {
                    alert("Date incompatible with financial year");
                  }
                }}
                readOnly={isFieldReadOnly("InvoiceDate") || isFieldDisabled("InvoiceDate")}
                style={getInputStyle("InvoiceDate")}
              />
            </div>
            <div
              className="font-Inter w-full h-[20px] flex items-center justify-end"
              style={getContainerStyle("DetailsBtn")}
            >
              <button
                ref={(el) => {
                  registerRef("DetailsBtn")(el);
                  detailsBtnInputRef.current = el;
                }}
                onKeyDown={(e) => handleKeyDown(e, "DetailsBtn")}
                className="font-Inter rounded-[7px] bg-[#bcbcbc] h-full shrink-0 w-[60%] border border-[#4a4a4a] text-[10px] flex items-center justify-center border-none"
                type="button"
                disabled={isFieldDisabled("DetailsBtn")}
                style={getInputStyle("DetailsBtn")}
              >
                Details
              </button>
            </div>
          </div>
          <div className="font-Inter flex flex-col w-[18.9%] gap-1 pl-2">
            <div
              className="font-Inter w-full flex items-center justify-between h-[20px]"
              style={getContainerStyle("PurchaseAC")}
            >
              <label className="font-Inter text-nowrap w-[38%] text-left" style={getLabelStyle("PurchaseAC")}>
                Purchase A/C
              </label>
              <SherComboBox
                value={purchaseInfoData.purchaseAccId}
                onSelect={({ label, value }) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    purchaseAccId: value,
                    purchaseAccName: label,
                  })
                }
                onFreeInput={(text) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    purchaseAccId: "",
                    purchaseAccName: text,
                  })
                }
                comboRef={(el) => {
                  registerRef("PurchaseAC")(el);
                  purchaseAcInputRef.current = el;
                }}
                options={pAcc}
                inputClassName="w-full h-full pr-1 pl-[1px] border border-[#4a4a4a] text-[10px]"
                className="font-Inter w-[60%] h-full"
                inputHeight="20px"
                inlineStyles={getInputStyle("PurchaseAC", { fontSize: "10px" })}
                onKeyDown={(e) => handleKeyDown(e, "PurchaseAC")}
                clearable={false}
                showArrow={false}
                disabled={isFieldDisabled("PurchaseAC")}
              />
            </div>
            <div
              className="font-Inter w-full flex items-center justify-between h-[20px]"
              style={getContainerStyle("Type")}
            >
              <label className="font-Inter text-nowrap w-[38%] text-left" style={getLabelStyle("Type")}>
                Type
              </label>
              <SherComboBox
                value={purchaseInfoData.typeId}
                onSelect={({ label, value }) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    typeId: value,
                    typeName: label,
                  })
                }
                onFreeInput={(text) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    typeId: "",
                    typeName: text,
                  })
                }
                comboRef={(el) => {
                  registerRef("Type")(el);
                  typeInputRef.current = el;
                }}
                options={typeOpts}
                inputClassName="w-full h-full p-0 ml-0 pl-[1px] border border-[#4a4a4a] text-[10px]"
                className="font-Inter w-[60%] h-full"
                inputHeight="20px"
                inlineStyles={getInputStyle("Type", { fontSize: "10px" })}
                onKeyDown={(e) => handleKeyDown(e, "Type")}
                clearable={false}
                showArrow={false}
                disabled={isFieldDisabled("Type")}
              />
            </div>
            <div
              className="font-Inter w-full flex items-center justify-between h-[20px]"
              style={getContainerStyle("OB")}
            >
              <label className="font-Inter text-nowrap w-[38%] text-left" style={getLabelStyle("OB")}>
                OB
              </label>
              <input
                onChange={(e) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    ob: e.target.value,
                  })
                }
                value={purchaseInfoData.ob}
                ref={(el) => {
                  registerRef("OB")(el);
                  obInputRef.current = el;
                }}
                onKeyDown={(e) => handleKeyDown(e, "OB")}
                className="font-Inter w-[60%] h-full px-2 box-border border border-[#4a4a4a] text-[10px]"
                readOnly={isFieldReadOnly("OB") || isFieldDisabled("OB")}
                style={getInputStyle("OB")}
              />
            </div>
          </div>
          <div className="font-Inter flex flex-col w-[15.9%] gap-1 pl-2">
            <div
              className="font-Inter w-full h-[20px] flex items-center justify-between"
              style={getContainerStyle("Salesman")}
            >
              <label className="font-Inter text-nowrap w-[38%] text-left" style={getLabelStyle("Salesman")}>
                Salesman
              </label>
              <SherComboBox
                value={purchaseInfoData.salesmanId}
                onSelect={({ label, value }) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    salesmanId: value,
                    salesmanName: label,
                  })
                }
                onFreeInput={(text) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    salesmanId: "",
                    salesmanName: text,
                  })
                }
                comboRef={(el) => {
                  registerRef("Salesman")(el);
                  salesManInputRef.current = el;
                }}
                className="font-Inter w-[60%] h-full"
                inputClassName="border border-[#4a4a4a] text-[10px] w-full"
                inputHeight="20px"
                inlineStyles={getInputStyle("Salesman", { fontSize: "10px" })}
                options={salesmanOpts}
                onKeyDown={(e) => handleKeyDown(e, "Salesman")}
                clearable={false}
                showArrow={false}
                disabled={isFieldDisabled("Salesman")}
              />
            </div>
            <div
              className="font-Inter w-full h-[20px] flex items-center justify-between"
              style={getContainerStyle("Location")}
            >
              <label className="font-Inter text-nowrap w-[38%] text-left" style={getLabelStyle("Location")}>
                Location
              </label>
              <SherComboBox
                value={purchaseInfoData.locationId}
                onSelect={({ label, value }) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    locationId: value,
                    locationName: label,
                  })
                }
                onFreeInput={(text) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    locationId: "",
                    locationName: text,
                  })
                }
                className="font-Inter w-[60%] h-full"
                inputClassName="border border-[#4a4a4a] text-[10px] w-full"
                inputHeight="20px"
                inlineStyles={getInputStyle("Location", { fontSize: "10px" })}
                comboRef={(el) => {
                  registerRef("Location")(el);
                  locationInputRef.current = el;
                }}
                options={locationOpts}
                clearable={false}
                showArrow={false}
                disabled={isFieldDisabled("Location")}
                onKeyDown={(e) => handleKeyDown(e, "Location")}
              />
            </div>
            <div
              className="font-Inter w-full h-[20px] flex items-center justify-between"
              style={getContainerStyle("OW")}
            >
              <label className="font-Inter text-nowrap w-[38%] text-left" style={getLabelStyle("OW")}>
                OW
              </label>
              <input
                onChange={(e) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    ow: e.target.value,
                  })
                }
                value={purchaseInfoData.ow}
                ref={(el) => {
                  registerRef("OW")(el);
                  owInputRef.current = el;
                }}
                onKeyDown={(e) => handleKeyDown(e, "OW")}
                className="font-Inter w-[60%] h-full px-2 box-border border border-[#4a4a4a] text-[10px]"
                readOnly={isFieldReadOnly("OW") || isFieldDisabled("OW")}
                style={getInputStyle("OW")}
              />
            </div>
          </div>
        </div>

        {/* ............................purchase entry data table........................................ */}

        <div
          className="font-Inter w-[97.7%] shrink-0 flex flex-col text-black text-[10px] font-semibold leading-normal overflow-auto mt-2 flex-grow h-0 min-h-[140px]"
          ref={tableContainerRef}
          onScroll={handleScroll}
        >
          <div className="w-max min-w-full h-max flex sticky z-30 top-0">
            <div className="w-max min-w-full h-[1.5rem] bg-[#026CC3] flex">
              {gridColumns.map((col) => {
                if (!col.show) return null;
                return (
                  <div
                    key={col.columnName}
                    style={{ width: `${col.width}px`, flexShrink: 0 }}
                    className="h-full border-b border-r border-[#ccc] flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center"
                  >
                    {col.header}
                  </div>
                );
              })}
              {/* Action column (bin icon header) */}
              <div
                style={{ width: "40px", flexShrink: 0 }}
                className="h-full border-b border-r border-[#ccc] flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center"
              ></div>
            </div>
          </div>
          {/* /////table Body/// */}
          <div className="w-full h-max flex flex-col">
            {tableData.map((rowData, rowIndex) => (
              <div
                key={rowIndex}
                className="puchaseTbodyrow w-max min-w-full h-[3rem] bg-white flex flex-col"
              >
                <div className="puchaseRow w-max min-w-full h-1/2 bg-white flex">
                  {gridColumns.map((col, visibleIndex) => {
                    if (!col.show) return null;
                    const colStyle = { width: `${col.width}px`, flexShrink: 0 };

                    if (col.columnName === "Slno") {
                      return (
                        <div
                          key={col.columnName}
                          style={colStyle}
                          className="h-full border-b border-r border-[#ccc] flex items-center justify-center font-inter text-xs font-medium leading-[15px] tracking-normal text-center"
                        >
                          {rowIndex + 1}
                        </div>
                      );
                    }
                    if (col.columnName === "ItemCode") {
                      return (
                        <div
                          key={col.columnName}
                          style={colStyle}
                          className="h-full border-b border-r border-[#ccc] flex items-center justify-center font-inter text-xs font-medium leading-[15px] tracking-normal"
                        >
                          <SherComboBox
                            id={`grid_${rowIndex}_ItemCode`}
                            value={tableData[rowIndex]?.ItemCodeId}
                            disabled={isFieldDisabled("grid_ItemCode")}
                            onSelect={({ label, value }) => {
                              setpurchaseInfoData({
                                ...purchaseInfoData,
                                roundOff: "",
                              });
                              const newData = [...tableData];
                              newData[rowIndex] = {
                                ...newData[rowIndex],
                                ItemCodeId: value,
                                ItemCodeLabel: label,
                              };
                              setTableData(newData);
                              fetchTaxgroup(rowIndex, value);
                            }}
                            onFreeInput={(text) => {
                              setpurchaseInfoData({
                                ...purchaseInfoData,
                                roundOff: "",
                              });
                              const newData = [...tableData];
                              newData[rowIndex] = {
                                ...newData[rowIndex],
                                ItemCodeId: "",
                                ItemCodeLabel: text,
                              };
                              setTableData(newData);
                            }}
                            options={pCode}
                            onKeyDown={(e) =>
                              handleKeyDownTable(e, rowIndex, visibleIndex)
                            }
                            className="font-Inter h-[95%] w-full border-none p-0 m-0"
                            inputClassName="border-none w-full"
                            comboRef={registerRef(`grid_${rowIndex}_ItemCode`)}
                            dropdownWidth="200px"
                            onBlur={(e) =>
                              handleCheckProductList(
                                e,
                                rowIndex,
                                visibleIndex,
                                "itemCode",
                              )
                            }
                            clearable={false}
                            showArrow={false}
                          />
                        </div>
                      );
                    }
                    if (col.columnName === "ItemName") {
                      return (
                        <div
                          key={col.columnName}
                          style={colStyle}
                          className="h-full border-b border-r border-[#ccc] flex items-center justify-center font-inter text-xs font-medium leading-[15px] tracking-normal"
                        >
                          <SherComboBox
                            id={`grid_${rowIndex}_ItemName`}
                            value={tableData[rowIndex]?.ProductNameId}
                            disabled={isFieldDisabled("grid_ItemName")}
                            onSelect={({ label, value }) => {
                              setpurchaseInfoData({
                                ...purchaseInfoData,
                                roundOff: "",
                              });
                              const newData = [...tableData];
                              newData[rowIndex] = {
                                ...newData[rowIndex],
                                ProductNameId: value,
                                ProductNameLabel: label,
                              };
                              setTableData(newData);
                              fetchTaxgroup(rowIndex, value);
                            }}
                            onFreeInput={(text) => {
                              setpurchaseInfoData({
                                ...purchaseInfoData,
                                roundOff: "",
                              });
                              const newData = [...tableData];
                              newData[rowIndex] = {
                                ...newData[rowIndex],
                                ProductNameId: "",
                                ProductNameLabel: text,
                              };
                              setTableData(newData);
                            }}
                            options={pNames}
                            onKeyDown={(e) =>
                              handleKeyDownTable(e, rowIndex, visibleIndex)
                            }
                            className="font-Inter h-[95%] w-full border-none p-0 m-0"
                            inputClassName="border-none w-full"
                            comboRef={registerRef(`grid_${rowIndex}_ItemName`)}
                            dropdownWidth="200px"
                            onBlur={(e) =>
                              handleCheckProductList(
                                e,
                                rowIndex,
                                visibleIndex,
                                "itemName",
                              )
                            }
                            clearable={false}
                            showArrow={false}
                          />
                        </div>
                      );
                    }
                    if (col.columnName === "ModelName") {
                      return (
                        <div
                          key={col.columnName}
                          style={colStyle}
                          className="h-full border-b border-r border-[#ccc] flex items-center justify-center font-inter text-xs font-medium leading-[15px] tracking-normal"
                        >
                          <SherComboBox
                            id={`grid_${rowIndex}_ModelName`}
                            value={tableData[rowIndex]?.ModelNameId}
                            disabled={isFieldDisabled("grid_ModelName")}
                            onSelect={({ label, value }) => {
                              setpurchaseInfoData({
                                ...purchaseInfoData,
                                roundOff: "",
                              });
                              const newData = [...tableData];
                              newData[rowIndex] = {
                                ...newData[rowIndex],
                                ModelNameId: value,
                                ModelNameLabel: label,
                              };
                              PurchaseTableCalculations(
                                newData[rowIndex],
                                purchaseInfoData.taxType,
                              );
                              setTableData(newData);
                            }}
                            onFreeInput={(text) => {
                              setpurchaseInfoData({
                                ...purchaseInfoData,
                                roundOff: "",
                              });
                              const newData = [...tableData];
                              newData[rowIndex] = {
                                ...newData[rowIndex],
                                ModelNameId: "",
                                ModelNameLabel: text,
                              };
                              PurchaseTableCalculations(
                                newData[rowIndex],
                                purchaseInfoData.taxType,
                              );
                              setTableData(newData);
                            }}
                            options={modelOpts}
                            onKeyDown={(e) =>
                              handleKeyDownTable(e, rowIndex, visibleIndex)
                            }
                            className="font-Inter h-[95%] w-full border-none p-0 m-0"
                            inputClassName="border-none w-full"
                            comboRef={registerRef(`grid_${rowIndex}_ModelName`)}
                            dropdownWidth="200px"
                            clearable={false}
                            showArrow={false}
                          />
                        </div>
                      );
                    }

                    const fieldMap = {
                      PRate: { key: "RateGm", index: 4 },
                      Qty: { key: "Qty", index: 5 },
                      GrWt: { key: "GrWt", index: 6 },
                      StoneWt: { key: "StoneWt", index: 7 },
                      MudLess: { key: "MudLess", index: 8, isMudLess: true },
                      Wstg: { key: "WstgGm", index: 10 },
                      NetWt: { key: "NetWeight" },
                      Touch: { key: "Touchperc", index: 11 },
                      Div: { key: "Divperc", index: 12 },
                      StoneAmt: { key: "StoneAmt", index: 13 },
                      Mc: { key: "Mc", index: 14, isMc: true },
                      Gross: { key: "GrossValue" },
                      CGST: { key: "CGST", readOnly: true },
                      SGST: { key: "SGST", readOnly: true },
                      IGST: { key: "IGST", readOnly: true },
                      Net: { key: "TotalAmount" },
                    };

                    const fieldConfig = fieldMap[col.columnName];
                    if (fieldConfig) {
                      const { key, readOnly, isMudLess, isMc } = fieldConfig;
                      return (
                        <div
                          key={col.columnName}
                          style={colStyle}
                          className="h-full border-b border-r border-[#ccc] flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center"
                        >
                          <input
                            id={`grid_${rowIndex}_${col.columnName}`}
                            type="number"
                            value={tableData[rowIndex][key]}
                            readOnly={
                              readOnly ||
                              isFieldReadOnly(`grid_${col.columnName}`)
                            }
                            disabled={isFieldDisabled(`grid_${col.columnName}`)}
                            onChange={(e) => handleCellChange(e, rowIndex, key)}
                            ref={registerRef(`grid_${rowIndex}_${col.columnName}`)}
                            onKeyDown={(e) => {
                              if (isMudLess) {
                                handleKeyDown(e, lesspercInputRef);
                                return;
                              }

                              const isBreakout =
                                breakoutColumn &&
                                col.columnName.toLowerCase() === breakoutColumn.toLowerCase() &&
                                (!e.target.value || e.target.value.trim() === "");

                              if (isBreakout) {
                                handleKeyDownTable(e, rowIndex, visibleIndex);
                              } else if (col.columnName === (rowBreakColumn || "Mc")) {
                                if (e.key === "Enter" || e.key === "Return") {
                                  e.preventDefault();
                                  if (!validatePurchaseRow(rowIndex)) {
                                    return;
                                  }
                                  addRow();
                                  setTimeout(() => {
                                    const gridFields = formFields
                                      .filter(f => f.fieldId.startsWith("grid_") && f.visible !== false && f.enabled !== false)
                                      .sort((a, b) => (a.tabIndex ?? 9999) - (b.tabIndex ?? 9999));
                                    const firstCol = gridFields[0]?.fieldId.replace("grid_", "") || "ItemCode";
                                    const targetCol = rowBreakTarget || firstCol;
                                    focusField(`grid_${rowIndex + 1}_${targetCol}`);
                                  }, 50);
                                }
                              } else {
                                handleKeyDownTable(e, rowIndex, visibleIndex);
                              }
                            }}
                            className="font-Inter h-[95%] w-full border-none p-0 m-0 text-right"
                          />
                        </div>
                      );
                    }

                    return (
                      <div
                        key={col.columnName}
                        style={colStyle}
                        className="h-full border-b border-r border-[#ccc] flex items-center justify-center font-inter text-xs font-medium leading-[15px] tracking-normal text-center"
                      />
                    );
                  })}
                  {/* -----remove row icon---- */}
                  <div
                    style={{ width: "40px", flexShrink: 0 }}
                    className="h-full border-b border-r border-[#ccc] flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center"
                  >
                    <img
                      src={binImg}
                      alt="binImg"
                      className="cursor-pointer hover:opacity-80 pointer-events-auto"
                      onClick={() => handleRemoveRow(rowIndex)}
                    />
                  </div>
                </div>

                <div className="w-max min-w-full h-1/2 bg-[#EBEBEB] flex sticky">
                  {gridColumns
                    .filter((c) => c.show)
                    .map((col, idx, filteredList) => {
                      if (col.columnName === "ItemName") {
                        const isItemCodeVisible = filteredList.some(
                          (c) => c.columnName === "ItemCode",
                        );
                        if (isItemCodeVisible) return null;
                      }
                      if (col.columnName === "Div") {
                        const isTouchVisible = filteredList.some(
                          (c) => c.columnName === "Touch",
                        );
                        if (isTouchVisible) return null;
                      }

                      let colWidth = col.width;
                      if (col.columnName === "ItemCode") {
                        const itemNameCol = filteredList.find(
                          (c) => c.columnName === "ItemName",
                        );
                        if (itemNameCol) colWidth += itemNameCol.width;
                      }
                      if (col.columnName === "Touch") {
                        const divCol = filteredList.find(
                          (c) => c.columnName === "Div",
                        );
                        if (divCol) colWidth += divCol.width;
                      }

                      const colStyle = {
                        width: `${colWidth}px`,
                        flexShrink: 0,
                        borderRight: "1px solid transparent",
                      };

                      if (col.columnName === "ItemCode") {
                        return (
                          <div
                            key={col.columnName}
                            style={colStyle}
                            className="h-full pr-[1px] flex items-center justify-between font-inter text-xs font-medium leading-[15px] tracking-normal text-center"
                          >
                            {tableData[rowIndex].lessWt > 0 &&
                              `Less Weight:${tableData[rowIndex].lessWt}`}
                          </div>
                        );
                      }

                      if (col.columnName === "Touch") {
                        return (
                          <div
                            key={col.columnName}
                            style={colStyle}
                            className="h-full pr-[1px] flex items-center justify-center font-inter text-xs font-medium leading-[15px] tracking-normal text-center"
                          >
                            <input
                              type="number"
                              value={tableData[rowIndex]["thangam"]}
                              onChange={(e) =>
                                handleCellChange(e, rowIndex, "thangam")
                              }
                              className="font-Inter h-[95%] w-full border-none p-0 m-0 text-right bg-transparent focus:outline-none"
                            />
                          </div>
                        );
                      }

                      return (
                        <div
                          key={col.columnName}
                          style={colStyle}
                          className="h-full flex items-center justify-center font-inter text-xs font-medium leading-[15px] tracking-normal text-center"
                        />
                      );
                    })}
                  <div
                    style={{ width: "40px", flexShrink: 0 }}
                    className="h-full flex items-center justify-center font-inter text-xs font-medium leading-[15px] tracking-normal text-center"
                  />
                </div>
              </div>
            ))}
          </div>

          {/* //////////////////////////////////////////////////////////// */}

          <div className="w-max min-w-full h-[26px] bg-[#026cc3] flex text-[10px] font-semibold leading-normal text-white sticky bottom-0 z-30">
            <div
              style={{
                width: `${getColWidth("Slno") + getColWidth("ItemCode") + getColWidth("ItemName") + getColWidth("ModelName")}px`,
                flexShrink: 0,
              }}
              className="pr-[3px] gap-1 h-full flex items-center justify-center font-inter text-xs font-medium leading-[15px] tracking-normal text-center"
            >
              <label className="font-Inter text-white">Less%</label>
              <input
                type="number"
                value={tableData[RowIndex].lessPerc}
                ref={lesspercInputRef}
                onKeyDown={(e) => handleKeyDownTable(e, RowIndex, 8)}
                onChange={(e) => handleCellChange(e, RowIndex, "lessPerc")}
                className="font-Inter text-right w-1/4 h-[22px] border-none"
              />
              <label className="font-Inter text-white">Less Wt</label>
              <input
                type="number"
                ref={lesswtInputRef}
                value={tableData[RowIndex].lessWt}
                readOnly
                onKeyDown={(e) => handleKeyDownTable(e, RowIndex, 7)}
                className="font-Inter text-right w-1/3 h-[22px] border-none"
              />
            </div>
            <div
              style={{ width: `${getColWidth("PRate")}px`, flexShrink: 0 }}
              className="h-full flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center"
            ></div>
            <div
              style={{ width: `${getColWidth("Qty")}px`, flexShrink: 0 }}
              className="h-full flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center border-b border-r border-[#ccc]"
            >
              <input
                type="number"
                className="font-Inter text-right border-none w-full h-[22px] p-[1px]"
                value={purchaseInfoData.totalQty}
                onChange={(e) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    totalQty: e.target.value,
                  })
                }
              />
            </div>
            <div
              style={{ width: `${getColWidth("GrWt")}px`, flexShrink: 0 }}
              className="h-full flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center border-b border-r border-[#ccc]"
            >
              <input
                type="number"
                value={purchaseInfoData.totalGrWt}
                onChange={(e) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    totalGrWt: e.target.value,
                  })
                }
                className="font-Inter text-right w-full h-[22px] p-[1px] border-none"
              />
            </div>
            <div
              style={{ width: `${getColWidth("StoneWt")}px`, flexShrink: 0 }}
              className="h-full flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center border-b border-r border-[#ccc]"
            >
              <input
                type="number"
                value={purchaseInfoData.totalStonewt}
                onChange={(e) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    totalStonewt: e.target.value,
                  })
                }
                className="font-Inter text-right w-full h-[22px] p-[1px] border-none"
              />
            </div>
            <div
              style={{ width: `${getColWidth("MudLess")}px`, flexShrink: 0 }}
              className="h-full flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center border-b border-r border-[#ccc]"
            >
              <input
                type="number"
                value={purchaseInfoData.totalMudless}
                onChange={(e) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    totalMudless: e.target.value,
                  })
                }
                className="font-Inter text-right w-full h-[22px] p-[1px] border-none"
              />
            </div>
            <div
              style={{ width: `${getColWidth("Wstg")}px`, flexShrink: 0 }}
              className="h-full flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center border-b border-r border-[#ccc]"
            >
              <input
                type="number"
                value={purchaseInfoData.totalWstg}
                onChange={(e) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    totalWstg: e.target.value,
                  })
                }
                className="font-Inter text-right w-full h-[22px] p-[1px] border-none"
              />
            </div>
            <div
              style={{ width: `${getColWidth("NetWt")}px`, flexShrink: 0 }}
              className="h-full flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center border-b border-r border-[#ccc]"
            >
              <input
                type="number"
                value={purchaseInfoData.totalNetwt}
                onChange={(e) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    totalNetwt: e.target.value,
                  })
                }
                className="font-Inter text-right w-full h-[22px] p-[1px] border-none"
              />
            </div>
            <div
              style={{ width: `${getColWidth("Touch")}px`, flexShrink: 0 }}
              className="h-full flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center"
            ></div>
            <div
              style={{ width: `${getColWidth("Div")}px`, flexShrink: 0 }}
              className="h-full flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center"
            ></div>

            <div
              style={{ width: "0px", flexShrink: 0 }}
              className="border-none h-full flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center"
            >
              <input
                type="number"
                value={purchaseInfoData.totalNetAmount}
                onChange={(e) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    totalNetAmount: e.target.value,
                  })
                }
                className="font-Inter text-right w-full h-[22px] p-[1px] border-none"
                readOnly
              />
            </div>

            <div
              style={{ width: `${getColWidth("StoneAmt")}px`, flexShrink: 0 }}
              className="h-full flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center border-b border-r border-[#ccc]"
            >
              <input
                type="number"
                value={purchaseInfoData.totalStAmt}
                onChange={(e) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    totalStAmt: e.target.value,
                  })
                }
                className="font-Inter text-right w-full h-[22px] p-[1px] border-none"
              />
            </div>
            <div
              style={{ width: `${getColWidth("Mc")}px`, flexShrink: 0 }}
              className="h-full flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center border-b border-r border-[#ccc]"
            >
              <input
                type="number"
                value={purchaseInfoData.totalMc}
                onChange={(e) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    totalMc: e.target.value,
                  })
                }
                className="font-Inter text-right w-full h-[22px] p-[1px] border-none"
              />
            </div>
            <div
              style={{ width: `${getColWidth("Gross")}px`, flexShrink: 0 }}
              className="h-full flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center border-b border-r border-[#ccc]"
            >
              <input
                type="number"
                value={purchaseInfoData.totalGrossValue}
                onChange={(e) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    totalGrossValue: e.target.value,
                  })
                }
                className="font-Inter text-right w-full h-[22px] p-[1px] border-none"
              />
            </div>
            <div
              style={{ width: `${getColWidth("CGST")}px`, flexShrink: 0 }}
              className="h-full flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center border-b border-r border-[#ccc]"
            >
              <input
                type="number"
                value={purchaseInfoData.totalCgst}
                onChange={(e) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    totalCgst: e.target.value,
                  })
                }
                className="font-Inter text-right w-full h-[22px] p-[1px] border-none"
              />
            </div>
            <div
              style={{ width: `${getColWidth("SGST")}px`, flexShrink: 0 }}
              className="h-full flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center border-b border-r border-[#ccc]"
            >
              <input
                type="number"
                value={purchaseInfoData.totalSgst}
                onChange={(e) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    totalSgst: e.target.value,
                  })
                }
                className="font-Inter text-right w-full h-[22px] p-[1px] border-none"
              />
            </div>
            <div
              style={{ width: `${getColWidth("IGST")}px`, flexShrink: 0 }}
              className="h-full flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center border-b border-r border-[#ccc]"
            >
              <input
                type="number"
                value={purchaseInfoData.totalIgst}
                onChange={(e) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    totalIgst: e.target.value,
                  })
                }
                className="font-Inter text-right w-full h-[22px] p-[1px] border-none"
              />
            </div>
            <div
              style={{ width: `${getColWidth("Net")}px`, flexShrink: 0 }}
              className="h-full flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center border-b border-r border-[#ccc]"
            >
              <input
                type="number"
                value={purchaseInfoData.itemsTotalAmount}
                onChange={(e) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    itemsTotalAmount: e.target.value,
                  })
                }
                className="font-Inter text-right w-full h-[22px] p-[1px] border-none"
              />
            </div>
            <div
              style={{ width: "40px", flexShrink: 0 }}
              className="h-full flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center"
            ></div>
          </div>
        </div>

        <div className="font-Inter h-[190px] shrink-0 w-[97.6%] text-black text-[10px] font-semibold leading-normal flex items-center gap-[1%]">
          <div className="font-Inter w-[30%] h-[95%]">
            <div className="font-Inter w-full h-[18%] flex items-center text-white text-[10px] font-medium leading-normal">
              <button
                id="EditItemBtn"
                ref={editItembtnRef}
                className="font-Inter flex items-center justify-center w-[25%] h-[84%] rounded-[3px] bg-[#026cc3] mt-[1%] text-white border-none"
                style={getInputStyle("EditItemBtn")}
              >
                Edit Item
              </button>
              <button
                id="RemoveItemBtn"
                ref={removeItembtnRef}
                className="font-Inter flex items-center justify-center w-[25%] h-[84%] rounded-[3px] bg-[#026cc3] mt-[1%] ml-[1.5%] text-nowrap text-white border-none"
                style={getInputStyle("RemoveItemBtn")}
              >
                Remove Item
              </button>

              <input
                type="checkbox"
                className="w-4 h-4 ml-[5rem]"
                checked={purchaseInfoData.printOB}
                onChange={(e) =>
                  setpurchaseInfoData({
                    ...purchaseInfoData,
                    printOB: e.target.checked,
                  })
                }
                disabled={isFieldDisabled("PrintOB")}
                style={{
                  display: isFieldVisible("PrintOB") ? "inline-block" : "none",
                  ...getInputStyle("PrintOB"),
                }}
              />
              <label
                className="w-[5rem] font-Inter ml-[1rem]"
                style={{
                  display: isFieldVisible("PrintOB") ? "inline-block" : "none",
                  ...getLabelStyle("PrintOB"),
                }}
              >
                Print OB
              </label>
            </div>

            {/* /////tab section//// */}
            <div className="font-Inter mt-1 w-[95%] h-[70%] rounded-[4px] bg-white border border-[#606060]">
              <div className="font-Inter h-[22%] flex">
                <button
                  onClick={() => setActiveTab("default")}
                  className={`h-full w-1/3 text-[10px] font-semibold leading-normal flex items-center justify-center rounded-[3px] border-b border-r border-black ${
                    activeTab === "default" ? "bg-[#026cc3] text-white" : ""
                  }`}
                >
                  Default
                </button>
                <button
                  onClick={() => setActiveTab("tax")}
                  className={`h-full w-1/3 text-[10px] font-semibold leading-normal flex items-center justify-center rounded-[3px] border-b border-black ${
                    activeTab === "tax" ? "bg-[#026cc3] text-white" : ""
                  }`}
                >
                  Tax
                </button>
                <button
                  onClick={() => setActiveTab("expenses")}
                  className={`h-full w-1/3 text-[10px] font-semibold leading-normal flex items-center justify-center rounded-[3px] border-b border-l border-black ${
                    activeTab === "expenses" ? "bg-[#026cc3] text-white" : ""
                  }`}
                >
                  Expenses
                </button>
              </div>

              {activeTab === "default" && (
                <div className="font-Inter h-[78%] w-full flex flex-col items-center justify-center gap-2">
                  <div className="font-Inter w-[80%] h-[20px] flex items-center">
                    <label className="font-Inter w-[25%]">Rate / Gm </label>
                    <input className="font-Inter text-right w-[55%] h-full ml-[20%] rounded-[3px] border border-[#4a4a4a]" />
                  </div>
                  <div className="font-Inter w-[80%] h-[20px] flex items-center">
                    <label className="font-Inter w-[25%]">Stock</label>
                    <input className="font-Inter text-right w-[55%] h-full ml-[20%] rounded-[3px] border border-[#4a4a4a]" />
                  </div>
                  <div className="font-Inter w-[80%] h-[20px] flex items-center">
                    <label className="font-Inter w-[25%] text-nowrap">
                      Stone Amt{" "}
                    </label>
                    <input className="font-Inter text-right w-[55%] h-full ml-[20%] rounded-[3px] border border-[#4a4a4a]" />
                  </div>
                </div>
              )}

              {activeTab === "tax" && (
                <div className="font-Inter h-[78%] w-full flex flex-col items-center justify-center">
                  <div className="font-Inter w-full h-full bg-[#d9d9d9]">
                    {/* //////Head///// */}
                    <div className="font-Inter w-full h-[20%] flex">
                      <div className="font-Inter w-[19.8%] h-full bg-[#026cc3] text-white text-[10px] font-medium leading-normal flex items-center justify-center mr-[0.25%]">
                        Tax%
                      </div>
                      <div className="font-Inter w-[19.8%] h-full bg-[#026cc3] text-white text-[10px] font-medium leading-normal flex items-center justify-center mr-[0.25%]">
                        Taxable
                      </div>
                      <div className="font-Inter w-[19.8%] h-full bg-[#026cc3] text-white text-[10px] font-medium leading-normal flex items-center justify-center mr-[0.25%]">
                        IGST AMT
                      </div>
                      <div className="font-Inter w-[19.8%] h-full bg-[#026cc3] text-white text-[10px] font-medium leading-normal flex items-center justify-center mr-[0.25%]">
                        CGST AMT
                      </div>
                      <div className="font-Inter w-[19.8%] h-full bg-[#026cc3] text-white text-[10px] font-medium leading-normal flex items-center justify-center">
                        SGST AMT
                      </div>
                    </div>
                    {/* ////////Body//////// */}
                    {/* ////////Row1///////// */}
                    <div className="font-Inter w-full h-[20%] flex mb-[2.6%]">
                      <div className="font-Inter w-[19.8%] h-full bg-white text-black text-[10px] font-medium leading-normal flex items-center justify-center mr-[0.25%]">
                        <input
                          disabled
                          className="font-Inter w-full h-full border-none text-right"
                        />
                      </div>
                      <div className="font-Inter w-[19.8%] h-full bg-white text-black text-[10px] font-medium leading-normal flex items-center justify-center mr-[0.25%]">
                        <input
                          disabled
                          className="font-Inter w-full h-full border-none text-right"
                        />
                      </div>
                      <div className="font-Inter w-[19.8%] h-full bg-white text-black text-[10px] font-medium leading-normal flex items-center justify-center mr-[0.25%]">
                        <input
                          disabled
                          className="font-Inter w-full h-full border-none text-right"
                        />
                      </div>
                      <div className="font-Inter w-[19.8%] h-full bg-white text-black text-[10px] font-medium leading-normal flex items-center justify-center mr-[0.25%]">
                        <input
                          disabled
                          className="font-Inter w-full h-full border-none text-right"
                        />
                      </div>
                      <div className="font-Inter w-[19.8%] h-full bg-white text-black text-[10px] font-medium leading-normal flex items-center justify-center">
                        <input
                          disabled
                          className="font-Inter w-full h-full border-none text-right"
                        />
                      </div>
                    </div>
                    {/* ////////Row2///////// */}

                    <div className="font-Inter w-full h-[20%] flex mb-[2.6%]">
                      <div className="font-Inter w-[19.8%] h-full bg-white text-black text-[10px] font-medium leading-normal flex items-center justify-center mr-[0.25%]">
                        <input
                          disabled
                          className="font-Inter w-full h-full border-none text-right"
                        />
                      </div>
                      <div className="font-Inter w-[19.8%] h-full bg-white text-black text-[10px] font-medium leading-normal flex items-center justify-center mr-[0.25%]">
                        <input
                          disabled
                          className="font-Inter w-full h-full border-none text-right"
                        />
                      </div>
                      <div className="font-Inter w-[19.8%] h-full bg-white text-black text-[10px] font-medium leading-normal flex items-center justify-center mr-[0.25%]">
                        <input
                          disabled
                          className="font-Inter w-full h-full border-none text-right"
                        />
                      </div>
                      <div className="font-Inter w-[19.8%] h-full bg-white text-black text-[10px] font-medium leading-normal flex items-center justify-center mr-[0.25%]">
                        <input
                          disabled
                          className="font-Inter w-full h-full border-none text-right"
                        />
                      </div>
                      <div className="font-Inter w-[19.8%] h-full bg-white text-black text-[10px] font-medium leading-normal flex items-center justify-center">
                        <input
                          disabled
                          className="font-Inter w-full h-full border-none text-right"
                        />
                      </div>
                    </div>
                    {/* ////////Row3///////// */}

                    <div className="font-Inter w-full h-[20%] flex mb-[2.6%]">
                      <div className="font-Inter w-[19.8%] h-full bg-white text-black text-[10px] font-medium leading-normal flex items-center justify-center mr-[0.25%]">
                        <input
                          disabled
                          className="font-Inter w-full h-full border-none text-right"
                        />
                      </div>
                      <div className="font-Inter w-[19.8%] h-full bg-white text-black text-[10px] font-medium leading-normal flex items-center justify-center mr-[0.25%]">
                        <input
                          disabled
                          className="font-Inter w-full h-full border-none text-right"
                        />
                      </div>
                      <div className="font-Inter w-[19.8%] h-full bg-white text-black text-[10px] font-medium leading-normal flex items-center justify-center mr-[0.25%]">
                        <input
                          disabled
                          className="font-Inter w-full h-full border-none text-right"
                        />
                      </div>
                      <div className="font-Inter w-[19.8%] h-full bg-white text-black text-[10px] font-medium leading-normal flex items-center justify-center mr-[0.25%]">
                        <input
                          disabled
                          className="font-Inter w-full h-full border-none text-right"
                        />
                      </div>
                      <div className="font-Inter w-[19.8%] h-full bg-white text-black text-[10px] font-medium leading-normal flex items-center justify-center">
                        <input
                          disabled
                          className="font-Inter w-full h-full border-none text-right"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "expenses" && (
                <div className="font-Inter h-[78%] w-full flex flex-col items-center justify-center">
                  <div className="font-Inter w-full h-full bg-[#d9d9d9]">
                    {/* //////Head///// */}
                    <div className="font-Inter w-full h-[20%] flex">
                      <div className="font-Inter w-[33.166%] h-full bg-[#026cc3] text-white text-[10px] font-medium leading-normal flex items-center justify-center mr-[0.25%]">
                        Debit
                      </div>
                      <div className="font-Inter w-[33.166%] h-full bg-[#026cc3] text-white text-[10px] font-medium leading-normal flex items-center justify-center mr-[0.25%]">
                        Credit
                      </div>
                      <div className="font-Inter w-[33.166%] h-full bg-[#026cc3] text-white text-[10px] font-medium leading-normal flex items-center justify-center">
                        Amount
                      </div>
                    </div>
                    {/* ////////Body//////// */}
                    {/* ////////Row1///////// */}
                    <div className="font-Inter w-full h-[20%] flex mb-[3.2%]">
                      <div className="font-Inter w-[33.166%] h-full bg-white text-black text-[10px] font-medium leading-normal flex items-center justify-center mr-[0.25%]">
                        <input
                          disabled
                          className="font-Inter w-full h-full border-none text-right"
                        />
                      </div>
                      <div className="font-Inter w-[33.166%] h-full bg-white text-black text-[10px] font-medium leading-normal flex items-center justify-center mr-[0.25%]">
                        <input
                          disabled
                          className="font-Inter w-full h-full border-none text-right"
                        />
                      </div>
                      <div className="font-Inter w-[33.166%] h-full bg-white text-black text-[10px] font-medium leading-normal flex items-center justify-center">
                        <input
                          disabled
                          className="font-Inter w-full h-full border-none text-right"
                        />
                      </div>
                    </div>
                    {/* ////////Row2///////// */}

                    <div className="font-Inter w-full h-[20%] flex mb-[3.2%]">
                      <div className="font-Inter w-[33.166%] h-full bg-white text-black text-[10px] font-medium leading-normal flex items-center justify-center mr-[0.25%]">
                        <input
                          disabled
                          className="font-Inter w-full h-full border-none text-right"
                        />
                      </div>
                      <div className="font-Inter w-[33.166%] h-full bg-white text-black text-[10px] font-medium leading-normal flex items-center justify-center mr-[0.25%]">
                        <input
                          disabled
                          className="font-Inter w-full h-full border-none text-right"
                        />
                      </div>
                      <div className="font-Inter w-[33.166%] h-full bg-white text-black text-[10px] font-medium leading-normal flex items-center justify-center">
                        <input
                          disabled
                          className="font-Inter w-full h-full border-none text-right"
                        />
                      </div>
                    </div>
                    {/* ////////Row3///////// */}

                    <div className="font-Inter w-full h-[20%] flex mb-[3.2%] bg-[#026cc3]">
                      <div className="font-Inter h-full w-[33.33%] flex items-center justify-center">
                        <button
                          className="font-Inter h-[80%] w-[70%] bg-white rounded-[5px] text-black text-[10px] font-semibold leading-normal text-center border border-[#7d7d7d]"
                          type="button"
                        >
                          Remove
                        </button>
                      </div>
                      <div className="font-Inter h-full w-[33.33%] flex items-center justify-center">
                        <div className="font-Inter h-[80%] w-[70%] bg-white rounded-[5px] text-black text-[10px] font-semibold leading-normal text-center border border-[#7d7d7d]"></div>
                      </div>
                      <div className="font-Inter h-full w-[33.33%] flex items-center justify-center">
                        <button className="font-Inter h-[80%] w-[70%] bg-white rounded-[5px] text-black text-[10px] font-semibold leading-normal text-center border border-[#7d7d7d]">
                          Add Ad Cost
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="font-Inter w-[38%] h-[95%]">
            <div className="w-full h-[35%] flex flex-col">
              <div className="w-full h-1/2 flex">
                <div className="w-1/2 h-full flex items-center" style={getContainerStyle("CashAC")}>
                  <label className="w-[5rem] font-Inter" style={getLabelStyle("CashAC")}>Cash Acc</label>
                  <SherComboBox
                    value={purchaseInfoData.cashAccId}
                    onSelect={({ label, value }) =>
                      setpurchaseInfoData({
                        ...purchaseInfoData,
                        cashAccId: value,
                        cashAccName: label,
                      })
                    }
                    onFreeInput={(text) =>
                      setpurchaseInfoData({
                        ...purchaseInfoData,
                        cashAccId: "",
                        cashAccName: text,
                      })
                    }
                    comboRef={(el) => {
                      registerRef("CashAC")(el);
                      cashAccInputRef.current = el;
                    }}
                    inputClassName="font-Inter rounded-[3px] border border-[#4a4a4a]"
                    className="h-[20px] w-[62%] pr-[2px]"
                    options={caba}
                    inlineStyles={getInputStyle("CashAC")}
                    onKeyDown={(e) => handleKeyDown(e, "CashAC")}
                    clearable={false}
                    showArrow={false}
                  />
                </div>
                <div className="w-1/2 h-full flex items-center" style={getContainerStyle("TotalPureWt")}>
                  <label className="w-[7rem] font-Inter text-nowrap" style={getLabelStyle("TotalPureWt")}>
                    Total Pure Wt
                  </label>
                  <input
                    id="TotalPureWt"
                    value={purchaseInfoData.totalPureWt}
                    onChange={(e) =>
                      setpurchaseInfoData({
                        ...purchaseInfoData,
                        totalPureWt: e.target.value,
                      })
                    }
                    readOnly={isFieldReadOnly("TotalPureWt") || isFieldDisabled("TotalPureWt")}
                    className="font-Inter text-right rounded-[3px] border border-[#4a4a4a] h-[20px] w-3/5"
                    style={getInputStyle("TotalPureWt")}
                  />
                </div>
              </div>
              <div className="w-full h-1/2 flex">
                <div className="w-1/2 h-full flex items-center" style={getContainerStyle("CashPaid")}>
                  <label className="w-[5rem] font-Inter" style={getLabelStyle("CashPaid")}>Cash Paid</label>
                  <input
                    value={purchaseInfoData.cashPaid}
                    onChange={(e) =>
                      setpurchaseInfoData({
                        ...purchaseInfoData,
                        cashPaid: e.target.value,
                      })
                    }
                    ref={(el) => {
                      registerRef("CashPaid")(el);
                      cashPaidInputRef.current = el;
                    }}
                    onKeyDown={(e) => handleKeyDown(e, "CashPaid")}
                    readOnly={isFieldReadOnly("CashPaid") || isFieldDisabled("CashPaid")}
                    className="font-Inter text-right rounded-[3px] border border-[#4a4a4a] h-[20px] w-3/5"
                    style={getInputStyle("CashPaid")}
                  />
                </div>
                <div className="w-1/2 h-full flex items-center" style={getContainerStyle("TotalLess")}>
                  <label className="w-[7rem] font-Inter text-nowrap" style={getLabelStyle("TotalLess")}>
                    Total Less
                  </label>
                  <input
                    id="TotalLess"
                    value={purchaseInfoData.totalLess}
                    onChange={(e) =>
                      setpurchaseInfoData({
                        ...purchaseInfoData,
                        totalLess: e.target.value,
                      })
                    }
                    readOnly={isFieldReadOnly("TotalLess") || isFieldDisabled("TotalLess")}
                    className="font-Inter text-right rounded-[3px] border border-[#4a4a4a] h-[20px] w-3/5"
                    style={getInputStyle("TotalLess")}
                  />
                </div>
              </div>
            </div>

            <div className="font-Inter rounded-[3px] border border-[#4a4a4a] ml-[5rem] w-[83.5%] h-[60%]" style={{ display: (!isFieldVisible("ExchangeNo") && !isFieldVisible("ExchangeAmt") && !isFieldVisible("ReturnNo") && !isFieldVisible("ReturnAmt")) ? "none" : "block" }}>
              <div className="font-Inter w-full h-1/2 flex" style={{ display: (!isFieldVisible("ExchangeNo") && !isFieldVisible("ExchangeAmt")) ? "none" : "flex" }}>
                <div className="font-Inter w-[33.33%] h-full flex flex-col justify-center items-center gap-[2%]" style={getContainerStyle("ExchangeNo")}>
                  <label className="font-Inter w-[70%] text-center" style={getLabelStyle("ExchangeNo")}>
                    Exchange No
                  </label>
                  <input
                    id="ExchangeNo"
                    value={purchaseInfoData.exchangeNo}
                    onChange={(e) =>
                      setpurchaseInfoData({
                        ...purchaseInfoData,
                        exchangeNo: e.target.value,
                      })
                    }
                    readOnly={isFieldReadOnly("ExchangeNo") || isFieldDisabled("ExchangeNo")}
                    className="font-Inter text-right w-[90%] h-[20px] rounded-[3px] border border-[#4a4a4a]"
                    style={getInputStyle("ExchangeNo")}
                  />
                </div>
                <div className="font-Inter w-[33.33%] h-full flex flex-col justify-center items-center gap-[2%]" style={getContainerStyle("ExchangeAmt")}>
                  <label className="font-Inter w-[70%] text-center text-nowrap" style={getLabelStyle("ExchangeAmt")}>
                    Exchange Amount
                  </label>
                  <input
                    id="ExchangeAmt"
                    value={purchaseInfoData.exchangeAmount}
                    onChange={(e) =>
                      setpurchaseInfoData({
                        ...purchaseInfoData,
                        exchangeAmount: e.target.value,
                      })
                    }
                    readOnly={isFieldReadOnly("ExchangeAmt") || isFieldDisabled("ExchangeAmt")}
                    className="font-Inter text-right w-[90%] h-[20px] rounded-[3px] border border-[#4a4a4a]"
                    style={getInputStyle("ExchangeAmt")}
                  />
                </div>
                <div className="font-Inter w-[33.33%] h-full flex items-center justify-center">
                  <button
                    id="ExchangeBtn"
                    className="font-Inter w-[80%] h-1/2 rounded-[3px] bg-[#026cc3] text-white text-[12px] font-medium leading-normal flex items-center justify-center mt-[13%] border-none"
                    style={getInputStyle("ExchangeBtn")}
                  >
                    Exchange
                  </button>
                </div>
              </div>
              <div className="font-Inter w-full h-1/2 flex" style={{ display: (!isFieldVisible("ReturnNo") && !isFieldVisible("ReturnAmt")) ? "none" : "flex" }}>
                <div className="font-Inter w-[33.33%] h-full flex flex-col justify-center items-center gap-[2%]" style={getContainerStyle("ReturnNo")}>
                  <label className="font-Inter w-[70%] text-center" style={getLabelStyle("ReturnNo")}>
                    Return No
                  </label>
                  <input
                    id="ReturnNo"
                    value={purchaseInfoData.returnNo}
                    onChange={(e) =>
                      setpurchaseInfoData({
                        ...purchaseInfoData,
                        returnNo: e.target.value,
                      })
                    }
                    readOnly={isFieldReadOnly("ReturnNo") || isFieldDisabled("ReturnNo")}
                    className="font-Inter text-right w-[90%] h-[20px] rounded-[3px] border border-[#4a4a4a]"
                    style={getInputStyle("ReturnNo")}
                  />
                </div>
                <div className="font-Inter w-[33.33%] h-full flex flex-col justify-center items-center gap-[2%]" style={getContainerStyle("ReturnAmt")}>
                  <label className="font-Inter w-[70%] text-center" style={getLabelStyle("ReturnAmt")}>
                    Return Amount
                  </label>
                  <input
                    id="ReturnAmt"
                    value={purchaseInfoData.returnAmount}
                    onChange={(e) =>
                      setpurchaseInfoData({
                        ...purchaseInfoData,
                        returnAmount: e.target.value,
                      })
                    }
                    readOnly={isFieldReadOnly("ReturnAmt") || isFieldDisabled("ReturnAmt")}
                    className="font-Inter text-right w-[90%] h-[20px] rounded-[3px] border border-[#4a4a4a]"
                    style={getInputStyle("ReturnAmt")}
                  />
                </div>
                <div className="font-Inter w-[33.33%] h-full flex items-center justify-center">
                  <button
                    id="ReturnBtn"
                    className="font-Inter w-[80%] h-1/2 rounded-[3px] bg-[#026cc3] text-white text-[12px] font-medium leading-normal flex items-center justify-center mt-[13%] border-none"
                    style={getInputStyle("ReturnBtn")}
                  >
                    Return
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="font-Inter w-[30%] h-[95%]">
            <div className="font-Inter w-full h-[70%] flex">
              <div className="font-Inter h-full w-1/2">
                <div className="font-Inter w-full h-1/3" style={{ display: (!isFieldVisible("TdsPerc") && !isFieldVisible("TdsAmt")) ? "none" : "block" }}>
                  <div className="font-Inter flex items-center justify-between w-full gap-[2.4%] h-full">
                    <label className="font-Inter mr-[2%]" style={{ display: (isFieldVisible("TdsPerc") || isFieldVisible("TdsAmt")) ? "inline-block" : "none", ...getLabelStyle("TdsPerc") }}>TDS</label>
                    <input
                      id="TdsPerc"
                      value={purchaseInfoData.tdsPerc}
                      onChange={(e) =>
                        setpurchaseInfoData({
                          ...purchaseInfoData,
                          tdsPerc: e.target.value,
                        })
                      }
                      style={{ display: isFieldVisible("TdsPerc") ? "inline-block" : "none", ...getInputStyle("TdsPerc") }}
                      readOnly={isFieldReadOnly("TdsPerc") || isFieldDisabled("TdsPerc")}
                      className="font-Inter text-right w-[40%] h-[20px] rounded-[3px] border border-[#4a4a4a]"
                    />
                    <input
                      className="font-Inter text-right h-[20px] w-[40%] rounded-[3px] border border-[#4a4a4a]"
                      id="TdsAmt"
                      value={purchaseInfoData.tdsAmount}
                      onChange={(e) =>
                        setpurchaseInfoData({
                          ...purchaseInfoData,
                          tdsAmount: e.target.value,
                        })
                      }
                      style={{ display: isFieldVisible("TdsAmt") ? "inline-block" : "none", ...getInputStyle("TdsAmt") }}
                      readOnly={isFieldReadOnly("TdsAmt") || isFieldDisabled("TdsAmt")}
                    />
                  </div>
                </div>

                <div className="w-full h-1/3 flex flex-col gap-1 justify-center items-center" style={getContainerStyle("CurrentWeight")}>
                  <label className="font-Inter" style={getLabelStyle("CurrentWeight")}>Current Weight</label>
                  <input
                    id="CurrentWeight"
                    value={purchaseInfoData.currentWeight}
                    readOnly
                    className="font-Inter text-right h-[20px] w-[97%]"
                    style={getInputStyle("CurrentWeight")}
                  />
                </div>
                <div className="w-full h-1/3 flex flex-col gap-1 justify-center items-center" style={getContainerStyle("CurrentBalance")}>
                  <label className="font-Inter" style={getLabelStyle("CurrentBalance")}>Current Balance</label>
                  <input
                    id="CurrentBalance"
                    value={purchaseInfoData.currentBalance}
                    readOnly
                    className="font-Inter text-right h-[20px] w-[97%]"
                    style={getInputStyle("CurrentBalance")}
                  />
                </div>
              </div>

              <div className="font-Inter w-1/2 h-full">
                <div className="font-Inter w-full h-[25%] flex items-center gap-[6.5%]" style={getContainerStyle("Cess")}>
                  <label className="font-Inter text-black text-[10px] font-semibold w-[39%] pl-[4%]" style={getLabelStyle("Cess")}>
                    Cess
                  </label>
                  <input
                    id="Cess"
                    value={purchaseInfoData.cess}
                    onChange={(e) => {
                      setpurchaseInfoData({
                        ...purchaseInfoData,
                        cess: e.target.value,
                      });
                    }}
                    readOnly={isFieldReadOnly("Cess") || isFieldDisabled("Cess")}
                    className="font-Inter text-right h-[20px] w-[50%] rounded-[3px] border border-[#4a4a4a]"
                    style={getInputStyle("Cess")}
                  />
                </div>
                <div className="font-Inter w-full h-[25%] flex items-center gap-[6.5%]" style={getContainerStyle("OtherCharges")}>
                  <label className="font-Inter text-black text-[10px] font-semibold w-[39%] pl-[4%]" style={getLabelStyle("OtherCharges")}>
                    Other Charge
                  </label>
                  <input
                    value={purchaseInfoData.otherCharge}
                    onChange={(e) =>
                      setpurchaseInfoData({
                        ...purchaseInfoData,
                        otherCharge: e.target.value,
                      })
                    }
                    ref={(el) => {
                      registerRef("OtherCharges")(el);
                      otherChargesInputRef.current = el;
                    }}
                    onKeyDown={(e) => handleKeyDown(e, "OtherCharges")}
                    readOnly={isFieldReadOnly("OtherCharges") || isFieldDisabled("OtherCharges")}
                    className="font-Inter text-right h-[20px] w-[50%] rounded-[3px] border border-[#4a4a4a]"
                    style={getInputStyle("OtherCharges")}
                  />
                </div>
                <div className="font-Inter w-full h-[25%] flex items-center gap-[6.5%]" style={getContainerStyle("Discount")}>
                  <label className="font-Inter text-black text-[10px] font-semibold w-[39%] pl-[4%]" style={getLabelStyle("Discount")}>
                    Discount
                  </label>
                  <input
                    value={purchaseInfoData.discount}
                    onChange={(e) =>
                      setpurchaseInfoData({
                        ...purchaseInfoData,
                        discount: e.target.value,
                      })
                    }
                    ref={(el) => {
                      registerRef("Discount")(el);
                      discountInputRef.current = el;
                    }}
                    onKeyDown={(e) => handleKeyDown(e, "Discount")}
                    readOnly={isFieldReadOnly("Discount") || isFieldDisabled("Discount")}
                    className="font-Inter text-right h-[20px] w-[50%] rounded-[3px] border border-[#4a4a4a]"
                    style={getInputStyle("Discount")}
                  />
                </div>
                <div className="font-Inter w-full h-[25%] flex items-center gap-[6.5%]" style={getContainerStyle("RoundOffAmt")}>
                  <button
                    ref={(el) => {
                      registerRef("RoundOff")(el);
                      roundOffInputRef.current = el;
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        roundoff();
                      }
                      handleKeyDown(e, "RoundOff");
                    }}
                    onClick={(e) => roundoff()}
                    className="font-Inter rounded-[3px] bg-[#bcbcbc] h-[20px] w-[36%] text-black text-[10px] font-semibold flex items-center justify-between ml-[3%] border border-[#4a4a4a]"
                    style={getInputStyle("RoundOff")}
                  >
                    Round Off
                  </button>
                  <input
                    id="RoundOffAmt"
                    value={purchaseInfoData.roundOff}
                    onChange={(e) =>
                      setpurchaseInfoData({
                        ...purchaseInfoData,
                        roundOff: e.target.value,
                      })
                    }
                    readOnly={isFieldReadOnly("RoundOffAmt") || isFieldDisabled("RoundOffAmt")}
                    className="font-Inter text-right h-[20px] w-[50%] rounded-[3px] border border-[#4a4a4a]"
                    style={getInputStyle("RoundOffAmt")}
                  />
                </div>
              </div>
            </div>
            <div className="font-Inter w-full h-[30%] flex items-center justify-center" style={getContainerStyle("GrandTotal")}>
              <div className="font-Inter h-[70.4%] w-[97%] flex bg-[#026cc3] rounded-[3px] ml-[2.4%]">
                <div className="font-Inter w-1/2 h-full bg-[#89abc4] rounded-l-[3px] text-white text-[20px] font-bold leading-normal flex items-center justify-center" style={getLabelStyle("GrandTotal")}>
                  Grand Total
                </div>
                <div className="font-Inter w-1/2 h-full bg-[#da9d31] rounded-r-[3px] text-white text-[20px] font-semibold leading-normal flex items-center justify-center">
                  <input
                    id="GrandTotal"
                    value={purchaseInfoData.grandTotal}
                    readOnly
                    className="w-full h-full bg-transparent border-none text-right pr-3 font-Inter font-[600] text-xl"
                    style={getInputStyle("GrandTotal")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {showFindDialog && (
          <div className="w-[30vw] h-[15vh] rounded-[10px] bg-[#f8f9f9] border border-[#4a4a4a] absolute flex items-center justify-center gap-[1vw] z-50">
            <input
              type="text"
              value={findEntryNo}
              onChange={(e) => setFindEntryNo(e.target.value)}
              placeholder="Enter Entry No"
              className="h-[3vh] w-[60%] px-2 border border-[#4a4a4a]"
            />
            <button
              onClick={handleFind}
              className="h-[4vh] w-[20%] rounded-[5px] bg-[rgba(0,8,180,0.73)] text-white text-center font-bold text-[16px]"
            >
              Find
            </button>

            <div
              className="absolute top-[5px] right-[5px] cursor-pointer w-[20px] h-[20px] bg-[#FB3B17] flex items-center justify-center border-none"
              onClick={() => {
                closeFindDialog();
                handleClear();
              }}
            >
              <img className="w-[10px] h-[10px]" src={close} alt="Close" />
            </div>
          </div>
        )}

        {showGridDesignModal && (
          <GridDesign
            onClose={() => setShowGridDesignModal(false)}
            formName={vType || "Purchase Entry"}
            initialColumns={defaultPurchaseGridColumns}
            zIndex={zIndex}
            onSave={(updatedCols) => {
              setGridColumns(updatedCols);
            }}
          />
        )}

        {showFormDesignModal && (
          <FormDesign
            onClose={() => setShowFormDesignModal(false)}
            formName={vType || "Purchase Entry"}
            initialFields={defaultPurchaseFormFields}
            zIndex={zIndex}
            highlightFieldId={activeFieldId}
            onSave={(updatedFields) => {
              setFormFields(updatedFields);
              // Sync row-break and breakout config values into context immediately
              const rowBreakColField = updatedFields.find(
                (f) => f.fieldId === "__GridRowBreakColumn",
              );
              const rowBreakTgtField = updatedFields.find(
                (f) => f.fieldId === "__GridRowBreakTarget",
              );
              const breakoutColField = updatedFields.find(
                (f) => f.fieldId === "__GridBreakoutColumn",
              );
              const breakoutTgtField = updatedFields.find(
                (f) => f.fieldId === "__GridBreakoutTarget",
              );
              if (rowBreakColField?.defaultValue)
                setRowBreakColumn(rowBreakColField.defaultValue);
              if (rowBreakTgtField?.defaultValue)
                setRowBreakTarget(rowBreakTgtField.defaultValue);
              if (breakoutColField?.defaultValue)
                setBreakoutColumn(breakoutColField.defaultValue);
              if (breakoutTgtField?.defaultValue)
                setBreakoutTarget(breakoutTgtField.defaultValue);
            }}
          />
        )}
      </div>
    </div>
  );
}

export default PurchaseEntry;
